import React from 'react';
import fetch from 'cross-fetch';
function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}
function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  _setPrototypeOf(subClass, superClass);
}
function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}
function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;
  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}
function _construct(Parent, args, Class) {
  if (_isNativeReflectConstruct()) {
    _construct = Reflect.construct;
  } else {
    _construct = function _construct(Parent, args, Class) {
      var a = [null];
      a.push.apply(a, args);
      var Constructor = Function.bind.apply(Parent, a);
      var instance = new Constructor();
      if (Class) _setPrototypeOf(instance, Class.prototype);
      return instance;
    };
  }
  return _construct.apply(null, arguments);
}
function _isNativeFunction(fn) {
  return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function _wrapNativeSuper(Class) {
  var _cache = typeof Map === "function" ? new Map() : undefined;
  _wrapNativeSuper = function _wrapNativeSuper(Class) {
    if (Class === null || !_isNativeFunction(Class)) return Class;
    if (typeof Class !== "function") {
      throw new TypeError("Super expression must either be null or a function");
    }
    if (typeof _cache !== "undefined") {
      if (_cache.has(Class)) return _cache.get(Class);
      _cache.set(Class, Wrapper);
    }
    function Wrapper() {
      return _construct(Class, arguments, _getPrototypeOf(this).constructor);
    }
    Wrapper.prototype = Object.create(Class.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: false,
        writable: true,
        configurable: true
      }
    });
    return _setPrototypeOf(Wrapper, Class);
  };
  return _wrapNativeSuper(Class);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _wrapRegExp(re, groups) {
  _wrapRegExp = function (re, groups) {
    return new BabelRegExp(re, undefined, groups);
  };
  var _RegExp = _wrapNativeSuper(RegExp);
  var _super = RegExp.prototype;
  var _groups = new WeakMap();
  function BabelRegExp(re, flags, groups) {
    var _this = _RegExp.call(this, re, flags);
    _groups.set(_this, groups || _groups.get(re));
    return _this;
  }
  _inherits(BabelRegExp, _RegExp);
  BabelRegExp.prototype.exec = function (str) {
    var result = _super.exec.call(this, str);
    if (result) result.groups = buildGroups(result, this);
    return result;
  };
  BabelRegExp.prototype[Symbol.replace] = function (str, substitution) {
    if (typeof substitution === "string") {
      var groups = _groups.get(this);
      return _super[Symbol.replace].call(this, str, substitution.replace(/\$<([^>]+)>/g, function (_, name) {
        return "$" + groups[name];
      }));
    } else if (typeof substitution === "function") {
      var _this = this;
      return _super[Symbol.replace].call(this, str, function () {
        var args = [];
        args.push.apply(args, arguments);
        if (typeof args[args.length - 1] !== "object") {
          args.push(buildGroups(args, _this));
        }
        return substitution.apply(this, args);
      });
    } else {
      return _super[Symbol.replace].call(this, str, substitution);
    }
  };
  function buildGroups(result, re) {
    var g = _groups.get(re);
    return Object.keys(g).reduce(function (groups, name) {
      groups[name] = result[g[name]];
      return groups;
    }, Object.create(null));
  }
  return _wrapRegExp.apply(this, arguments);
}
var withApiData = function withApiData(Component, Placeholder) {
  return /*#__PURE__*/function (_React$Component) {
    _inheritsLoose(ChaosLayoutWrapper, _React$Component);
    function ChaosLayoutWrapper(props) {
      var _this;
      _this = _React$Component.call(this, props) || this;
      _this.state = {
        data: ""
      };
      return _this;
    }
    var _proto = ChaosLayoutWrapper.prototype;
    _proto.componentDidMount = function componentDidMount() {
      var _this2 = this;
      if (this.props.url) {
        fetch(this.props.url).then(function (resp) {
          return resp.json();
        }).then(function (data) {
          return _this2.setState({
            data: data
          });
        });
      }
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
      var _this3 = this;
      if (this.props.url !== prevProps.url) {
        fetch(this.props.url).then(function (resp) {
          return resp.json();
        }).then(function (data) {
          return _this3.setState({
            data: data
          });
        });
      }
    };
    _proto.render = function render() {
      var data = this.state.data;
      var _this$props = this.props,
        prefetchedData = _this$props.prefetchedData,
        rest = _objectWithoutPropertiesLoose(_this$props, ["url", "prefetchedData"]);
      if (!data && !prefetchedData) {
        return /*#__PURE__*/React.createElement(Placeholder, rest);
      }
      if (prefetchedData) {
        return /*#__PURE__*/React.createElement(Component, _extends({
          data: _extends({}, prefetchedData)
        }, rest));
      } else {
        return /*#__PURE__*/React.createElement(Component, _extends({
          data: _extends({}, data)
        }, rest));
      }
    };
    return ChaosLayoutWrapper;
  }(React.Component);
};
function gtag() {
  window.dataLayer.push(arguments);
}
var pickMenu = function pickMenu(menus, variant) {
  return (menus.find(function (menu) {
    return menu.go_variant === variant;
  }) || {
    menu: []
  }).menu;
};
var withOptimize = function withOptimize(component, Placeholder) {
  var Component = component;
  var Wrapper = function Wrapper(props) {
    var data = props.data,
      rest = _objectWithoutPropertiesLoose(props, ["data"]);
    var _React$useState = React.useState(null),
      variant = _React$useState[0],
      setVariant = _React$useState[1];
    var goCallback = function goCallback(value) {
      console.log("Google Optimize - ", value);
      setVariant(value);
    };
    React.useEffect(function () {
      if (!data.google_optimize_exp_id) {
        return;
      }
      if (typeof window !== "undefined" && window.dataLayer) {
        gtag("event", "optimize.callback", {
          name: data.google_optimize_exp_id,
          callback: goCallback
        });
      } else {
        console.warn("Header: No dataLayer found to enable Optimize!");
      }
      return function () {
        gtag("event", "optimize.callback", {
          name: data.google_optimize_exp_id,
          callback: goCallback,
          remove: true
        });
      };
    }, []);
    if (data.google_optimize_exp_id) {
      if (variant === null) {
        return /*#__PURE__*/React.createElement(Placeholder, null);
      }
      var newData = _extends({}, data, {
        mega_menu: pickMenu(data.mega_menus, variant)
      });
      return /*#__PURE__*/React.createElement(Component, _extends({
        data: _extends({}, newData)
      }, rest));
    } else {
      return /*#__PURE__*/React.createElement(Component, _extends({
        data: _extends({}, data)
      }, rest));
    }
  };
  return Wrapper;
};
var pickMenu$1 = function pickMenu(menus, menuId) {
  return (menus.find(function (menu) {
    return menu.id === menuId;
  }) || {
    menu: []
  }).menu;
};
var withMegaMenu = function withMegaMenu(component) {
  var Component = component;
  var Wrapper = function Wrapper(props) {
    var data = props.data,
      menuId = props.menuId,
      rest = _objectWithoutPropertiesLoose(props, ["data", "menuId"]);
    if (menuId) {
      var newData = _extends({}, data, {
        mega_menu: pickMenu$1(data.mega_menus, menuId)
      });
      return /*#__PURE__*/React.createElement(Component, _extends({
        data: _extends({}, newData)
      }, rest));
    } else {
      return /*#__PURE__*/React.createElement(Component, _extends({
        data: _extends({}, data)
      }, rest));
    }
  };
  return Wrapper;
};
var CartContext = /*#__PURE__*/React.createContext(null);
var extractCartInfo = function extractCartInfo(link) {
  if (!link) {
    return {};
  }
  var match = link.match( /*#__PURE__*/_wrapRegExp(/#product\x2Dcode\x2D(.+)\x2Dqty\x2D([0-9]+)/, {
    productCode: 1,
    quantity: 2
  }));
  if (match && match.groups && match.groups.productCode && match.groups.quantity) {
    return {
      productCode: match.groups.productCode,
      quantity: match.groups.quantity
    };
  }
  return {};
};
var Link = function Link(_ref) {
  var settings = _ref.settings,
    children = _ref.children;
  var cart = React.useContext(CartContext);
  var _extractCartInfo = extractCartInfo(settings.link),
    productCode = _extractCartInfo.productCode,
    quantity = _extractCartInfo.quantity;
  return /*#__PURE__*/React.createElement("a", {
    href: settings.link,
    title: settings.label,
    className: settings.className,
    target: settings.target,
    id: settings.id,
    onClick: function onClick(e) {
      if (cart && cart.add && productCode && quantity) {
        e.preventDefault();
        cart.add(productCode, parseInt(quantity));
      }
    }
  }, children || settings.label);
};
var s = {
  "wrapper": "_1Zw4W",
  "has-submenu": "_A7tOC",
  "primary": "_2yV5q",
  "secondary": "_cZijp",
  "sub": "_13qlA",
  "icon": "_1v7Qk"
};
var Icon = function Icon(_ref) {
  var src = _ref.src;
  return /*#__PURE__*/React.createElement("div", {
    className: s.icon
  }, src && /*#__PURE__*/React.createElement("img", {
    src: src.urls.original,
    alt: src.title
  }));
};
var hasMenu = function hasMenu(menu) {
  return menu && menu.length > 0;
};
var Button = function Button(_ref2) {
  var settings = _ref2.settings,
    menu = _ref2.menu;
  var cart = React.useContext(CartContext);
  var _extractCartInfo = extractCartInfo(settings.link),
    productCode = _extractCartInfo.productCode,
    quantity = _extractCartInfo.quantity;
  return /*#__PURE__*/React.createElement("div", {
    className: s.wrapper + " " + (menu.length > 0 ? s["has-submenu"] : "")
  }, /*#__PURE__*/React.createElement("a", {
    href: settings.link,
    id: settings.id,
    rel: settings.rel,
    target: settings.target,
    className: s[settings.type],
    onClick: function onClick(e) {
      if (hasMenu(menu)) {
        e.preventDefault();
      }
      if (!hasMenu(menu) && cart && cart.add && productCode && quantity) {
        e.preventDefault();
        cart.add(productCode, parseInt(quantity));
      }
    },
    style: hasMenu(menu) ? {
      cursor: "default"
    } : {}
  }, settings.label), hasMenu(menu) && /*#__PURE__*/React.createElement("div", {
    className: s.sub
  }, menu.map(function (l) {
    return /*#__PURE__*/React.createElement(Link, {
      key: l.id,
      settings: l.link
    }, /*#__PURE__*/React.createElement(Icon, {
      src: l.icon
    }), l.link.label);
  })));
};
var SimpleButton = function SimpleButton(_ref3) {
  var settings = _ref3.settings;
  return /*#__PURE__*/React.createElement("a", {
    href: settings.link,
    id: settings.id,
    rel: settings.rel,
    target: settings.target,
    className: s[settings.type]
  }, settings.label);
};
var s$1 = {
  "container": "_3DLTW"
};
function Container(_ref) {
  var children = _ref.children,
    rest = _objectWithoutPropertiesLoose(_ref, ["children"]);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: s$1.container
  }, rest), children);
}
var s$2 = {
  "hamburger": "_1OsDK",
  "is-active": "_1RvaP",
  "hamburger-inner": "__11qO",
  "hamburger-box": "_3V0vE",
  "hamburger--squeeze": "_3K9ND"
};
function Hamburger(_ref) {
  var open = _ref.open,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: s$2.hamburger + " " + s$2["hamburger--squeeze"] + " " + (open && s$2["is-active"]),
    onClick: onClick
  }, /*#__PURE__*/React.createElement("span", {
    className: s$2["hamburger-box"]
  }, /*#__PURE__*/React.createElement("span", {
    className: s$2["hamburger-inner"]
  })));
}
var styles = {
  "spacing-top-sm": "_3UkRN",
  "spacing-bottom-sm": "_EjN6b",
  "spacing-both-sm": "_30hjm",
  "spacing-top": "_1keNk",
  "spacing-bottom": "_sIiQc",
  "spacing-both": "_KkU5H",
  "spacing-top-lg": "_2PnRr",
  "spacing-bottom-lg": "_10jgc",
  "spacing-both-lg": "_2gM12"
};
function Spacing(_ref) {
  var _ref$s = _ref.s,
    s = _ref$s === void 0 ? "both" : _ref$s,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: styles["spacing-" + s]
  }, children);
}
var s$3 = {
  "btn-close": "_1LS3X"
};
var ButonClose = function ButonClose(_ref) {
  var onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: s$3["btn-close"],
    onClick: onClick
  }, "Close search");
};
var s$4 = {
  "search": "_SR41R",
  "title": "_3LmXT",
  "input": "_1VIcp",
  "open": "_6NKJW",
  "search-wrapper": "_285Q3"
};
var Search = function Search(_ref) {
  var visible = _ref.visible,
    search = _ref.search,
    onClose = _ref.onClose;
  return /*#__PURE__*/React.createElement("div", {
    className: s$4.search + " " + (visible ? s$4.open : "")
  }, /*#__PURE__*/React.createElement(ButonClose, {
    onClick: onClose
  }), /*#__PURE__*/React.createElement(Spacing, null, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: s$4["search-wrapper"]
  }, /*#__PURE__*/React.createElement("h3", {
    className: s$4.title
  }, search.title), /*#__PURE__*/React.createElement("form", {
    action: search.link.link,
    method: "get"
  }, /*#__PURE__*/React.createElement("input", {
    type: "text",
    name: "query",
    placeholder: search.placeholder,
    className: s$4.input
  }))))));
};
var s$5 = {
  "fancy-title": "__6XlU",
  "icon": "_35Urc",
  "underlined": "_1T8j-"
};
function alt(src) {
  var segments = src.split("/");
  return segments[segments.length - 1];
}
function FancyTitle(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    _ref$underline = _ref.underline,
    underline = _ref$underline === void 0 ? "yes" : _ref$underline;
  return /*#__PURE__*/React.createElement("div", {
    className: [s$5["fancy-title"], underline === "yes" ? s$5.underlined : ""].join(" ")
  }, icon && /*#__PURE__*/React.createElement("img", {
    className: s$5.icon,
    src: icon,
    alt: alt(icon)
  }), /*#__PURE__*/React.createElement("h4", null, title));
}
var s$6 = {
  "w-spacing-top-sm": "_3A-xj",
  "w-spacing-top-md": "_oLjjI",
  "w-spacing-top-lg": "_19Hl8",
  "w-spacing-bottom-sm": "_3IQs1",
  "w-spacing-bottom-md": "_1WyUA",
  "w-spacing-bottom-lg": "_20ysz",
  "w-spacing-both-sm": "_3hlYN",
  "w-spacing-both-md": "_2pcRq",
  "w-spacing-both-lg": "_3_LyR"
};
var MAP = {
  "top-sm": s$6["w-spacing-top-sm"],
  "top-md": s$6["w-spacing-top-md"],
  "top-lg": s$6["w-spacing-top-lg"],
  "bottom-sm": s$6["w-spacing-bottom-sm"],
  "bottom-md": s$6["w-spacing-bottom-md"],
  "bottom-lg": s$6["w-spacing-bottom-lg"],
  "both-sm": s$6["w-spacing-both-sm"],
  "both-md": s$6["w-spacing-both-md"],
  "both-lg": s$6["w-spacing-both-lg"]
};
function Spacing$1(_ref) {
  var value = _ref.value,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: MAP[value]
  }, children);
}
function Title(_ref) {
  var title = _ref.title,
    icon = _ref.icon,
    underline = _ref.underline,
    spacing = _ref.spacing;
  return /*#__PURE__*/React.createElement(Spacing$1, {
    value: spacing
  }, /*#__PURE__*/React.createElement(FancyTitle, {
    title: title,
    icon: icon,
    underline: underline
  }));
}
function HTML(_ref) {
  var code = _ref.code;
  return /*#__PURE__*/React.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: code
    }
  });
}
var Link$1 = function Link(_ref) {
  var settings = _ref.settings,
    className = _ref.className,
    children = _ref.children;
  var label = settings.label,
    link = settings.link,
    id = settings.id,
    classNameSettings = settings.className,
    target = settings.target,
    rel = settings.rel;
  return /*#__PURE__*/React.createElement("a", {
    href: link,
    className: [classNameSettings, className].join(" "),
    id: id || "",
    target: target,
    rel: rel,
    title: label
  }, children || label);
};
function RightChevron(_ref) {
  var className = _ref.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "6",
    height: "10",
    viewBox: "0 0 6 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 9L5 5L1 1",
    stroke: "currentColor",
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function RightArrow(_ref2) {
  var className = _ref2.className;
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    width: "10",
    height: "10",
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.916748 4.99984H9.08342M9.08342 4.99984L5.00008 0.916504M9.08342 4.99984L5.00008 9.08317",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
var s$7 = {
  "fancy-link": "_1hiOl",
  "description": "_Riew_",
  "tag": "_2iiPJ",
  "icon": "_1m01Z",
  "label": "_33-HK",
  "black-label": "_o_rh6",
  "arr": "_1Sct3",
  "chev": "_eY-h8",
  "chev-move": "_1vwo8",
  "arr-move": "_1Grun"
};
function FancyLink(_ref) {
  var link = _ref.link,
    _ref$icon = _ref.icon,
    icon = _ref$icon === void 0 ? "" : _ref$icon,
    _ref$tag = _ref.tag,
    tag = _ref$tag === void 0 ? "" : _ref$tag,
    _ref$tag_color = _ref.tag_color,
    tag_color = _ref$tag_color === void 0 ? "" : _ref$tag_color,
    _ref$description = _ref.description,
    description = _ref$description === void 0 ? "" : _ref$description,
    _ref$arrow = _ref.arrow,
    arrow = _ref$arrow === void 0 ? "chevron" : _ref$arrow,
    _ref$blackLabel = _ref.blackLabel,
    blackLabel = _ref$blackLabel === void 0 ? false : _ref$blackLabel;
  return /*#__PURE__*/React.createElement(Link$1, {
    settings: link,
    className: s$7["fancy-link"]
  }, icon && /*#__PURE__*/React.createElement("img", {
    className: s$7.icon,
    src: icon
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: [s$7.label, blackLabel ? s$7["black-label"] : ""].join(" ")
  }, link.label, arrow === "chevron" && /*#__PURE__*/React.createElement(RightChevron, {
    className: s$7.chev
  }), arrow === "arrow" && /*#__PURE__*/React.createElement(RightArrow, {
    className: s$7.arr
  }), tag && /*#__PURE__*/React.createElement("em", {
    className: [s$7.tag, arrow === "chevron" ? s$7["chev-move"] : "", arrow === "arrow" ? s$7["arr-move"] : ""].join(" "),
    style: {
      backgroundColor: tag_color
    }
  }, tag)), description && /*#__PURE__*/React.createElement("p", {
    className: s$7.description
  }, description)));
}
var s$8 = {
  "links": "_1Dizn"
};
function Links(_ref) {
  var links = _ref.links,
    spacing = _ref.spacing;
  return /*#__PURE__*/React.createElement(Spacing$1, {
    value: spacing
  }, /*#__PURE__*/React.createElement("div", {
    className: s$8.links
  }, links.map(function (l, idx) {
    return /*#__PURE__*/React.createElement(FancyLink, _extends({
      key: idx + "-" + l.id
    }, l));
  })));
}
var s$9 = {
  "image_link": "_1q6QZ",
  "content": "_30MpQ",
  "arrow": "_1pvr1",
  "title": "_1BBGD",
  "description": "_11kyA",
  "sm": "_2G_-x",
  "md": "_gv87f",
  "lg": "_38COI"
};
var CLASSES_MAP = {
  "16/9": s$9.md,
  "1/1": s$9.lg,
  "32/10": s$9.sm
};
function Image(_ref) {
  var image = _ref.image,
    aspect_ratio = _ref.aspect_ratio,
    link = _ref.link,
    description = _ref.description,
    spacing = _ref.spacing;
  var ar = aspect_ratio || "16/9";
  return /*#__PURE__*/React.createElement(Spacing$1, {
    value: spacing
  }, /*#__PURE__*/React.createElement(Link$1, {
    className: s$9.image_link,
    settings: link
  }, /*#__PURE__*/React.createElement("img", {
    src: image,
    style: {
      aspectRatio: ar
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: [s$9.content, CLASSES_MAP[ar]].join(" ")
  }, (link === null || link === void 0 ? void 0 : link.label) && /*#__PURE__*/React.createElement("div", {
    className: s$9.title
  }, link === null || link === void 0 ? void 0 : link.label), description && /*#__PURE__*/React.createElement("div", {
    className: s$9.description,
    dangerouslySetInnerHTML: {
      __html: description
    }
  }))));
}
var s$a = {
  "banner": "_1JoIQ",
  "section": "_1QuxF",
  "inner-section": "_1N0uq",
  "icon": "_2xUjb",
  "logo": "_PKpaN",
  "last-mile": "_3fPpg"
};
function Banner(_ref) {
  var links = _ref.links,
    icon = _ref.icon,
    description = _ref.description,
    logo = _ref.logo,
    spacing = _ref.spacing;
  return /*#__PURE__*/React.createElement(Spacing$1, {
    value: spacing
  }, /*#__PURE__*/React.createElement("div", {
    className: s$a.banner
  }, /*#__PURE__*/React.createElement("div", {
    className: s$a.section
  }, links.map(function (l, idx) {
    return /*#__PURE__*/React.createElement(FancyLink, _extends({
      key: idx,
      blackLabel: true
    }, l));
  })), /*#__PURE__*/React.createElement("div", {
    className: [s$a.section, s$a["last-mile"]].join(" ")
  }, /*#__PURE__*/React.createElement("div", {
    className: s$a["inner-section"]
  }, icon && /*#__PURE__*/React.createElement("img", {
    className: s$a.icon,
    src: icon
  }), description && /*#__PURE__*/React.createElement("div", null, description)), logo && /*#__PURE__*/React.createElement("img", {
    className: s$a.logo,
    src: logo
  }))));
}
var s$b = {
  "switcher": "_39dln",
  "switch": "_2m76f",
  "title": "_3zwM9",
  "active-switch": "_3lDr4",
  "link-switch": "_2wscU"
};
function Chevron() {
  return /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.75 13.5L11.25 9L6.75 4.5",
    stroke: "currentColor",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}
function Switcher(_ref) {
  var tabs = _ref.tabs,
    active = _ref.active,
    setActive = _ref.setActive,
    _ref$links = _ref.links,
    links = _ref$links === void 0 ? [] : _ref$links,
    children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: s$b.switcher
  }, tabs.map(function (tab) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: tab.id
    }, /*#__PURE__*/React.createElement("div", {
      className: s$b["switch"] + " " + (active === tab.id ? s$b["active-switch"] : ""),
      onMouseEnter: function onMouseEnter() {
        return setActive(tab.id);
      },
      onClick: function onClick() {
        return setActive(tab.id);
      }
    }, active === tab.id ? /*#__PURE__*/React.createElement("img", {
      src: tab.active_icon,
      alt: tab.title
    }) : /*#__PURE__*/React.createElement("img", {
      src: tab.icon,
      alt: tab.title
    }), /*#__PURE__*/React.createElement("div", {
      className: s$b.title
    }, /*#__PURE__*/React.createElement("div", null, tab.title), /*#__PURE__*/React.createElement(Chevron, null))), active === tab.id && children);
  }), links.length > 0 && links.map(function (item) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: item.id
    }, /*#__PURE__*/React.createElement("div", {
      className: s$b["switch"]
    }, /*#__PURE__*/React.createElement(Link$1, {
      settings: item.link,
      className: s$b["link-switch"]
    }, item.link.label, item.tag && /*#__PURE__*/React.createElement("em", {
      style: {
        backgroundColor: item.tag_color
      }
    }, item.tag))));
  }));
}
var s$c = {
  "title": "_3ebxP",
  "inv": "_3Ealn"
};
function TabsFancyTitle(_ref) {
  var title = _ref.title,
    _ref$invisible = _ref.invisible,
    invisible = _ref$invisible === void 0 ? false : _ref$invisible;
  return /*#__PURE__*/React.createElement("div", {
    className: [s$c.title, invisible ? s$c.inv : ""].join(" ")
  }, /*#__PURE__*/React.createElement(FancyTitle, {
    title: title,
    underline: "no"
  }));
}
var s$d = {
  "highlights": "_3HMli",
  "card": "_25QlA",
  "icons": "_2z_zy",
  "title": "_1EI8A",
  "description": "_miEWa",
  "tags": "_2Gl3b",
  "tag": "_2fX5W",
  "mt-2": "_2hxIo",
  "mb-2": "_3lz18",
  "arrow-wrapper": "_1Vg5i",
  "image": "_BmXQo",
  "cards": "_2hNYV"
};
var s$e = {
  "bp-mobile-only": "_1VVlu",
  "bp-desktop-only": "_2uODo"
};
function Mobile(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: s$e["bp-mobile-only"]
  }, children);
}
function Desktop(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: s$e["bp-desktop-only"]
  }, children);
}
function Tags(_ref) {
  var list = _ref.list,
    cardArrow = _ref.cardArrow;
  return /*#__PURE__*/React.createElement("div", {
    className: s$d.tags,
    style: {
      marginBottom: cardArrow === "yes" ? "var(--cl-custom-spacing-sm)" : "0"
    }
  }, list.map(function (item) {
    return /*#__PURE__*/React.createElement("div", {
      className: s$d.tag,
      key: item.id
    }, item.name);
  }));
}
function Icons(_ref2) {
  var list = _ref2.list;
  return /*#__PURE__*/React.createElement("div", {
    className: [s$d.icons, s$d["mb-2"]].join(" ")
  }, list.map(function (item) {
    return /*#__PURE__*/React.createElement("img", {
      key: item.id,
      src: item.src
    });
  }));
}
function TitleAndIcons(_ref3) {
  var title = _ref3.title,
    icons = _ref3.icons,
    order = _ref3.order;
  if (order === "icons-title") {
    return /*#__PURE__*/React.createElement(React.Fragment, null, icons.length > 0 && /*#__PURE__*/React.createElement(Icons, {
      list: icons
    }), /*#__PURE__*/React.createElement("h5", {
      className: [s$d.title, s$d["mb-2"]].join(" ")
    }, title));
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("h5", {
    className: [s$d.title, s$d["mb-2"]].join(" ")
  }, title), icons.length > 0 && /*#__PURE__*/React.createElement(Icons, {
    list: icons
  }));
}
function ArrowIcon() {
  return /*#__PURE__*/React.createElement("div", {
    className: s$d["arrow-wrapper"]
  }, /*#__PURE__*/React.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "20",
    height: "21",
    viewBox: "0 0 20 21",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.16797 10.388H15.8346M15.8346 10.388L10.0013 4.55469M15.8346 10.388L10.0013 16.2214",
    stroke: "#828290",
    strokeWidth: "1.25",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
function Card(_ref4) {
  var image = _ref4.image,
    link = _ref4.link,
    description = _ref4.description,
    tags = _ref4.tags,
    icons = _ref4.icons,
    show_arrow = _ref4.show_arrow,
    _ref4$elements_order = _ref4.elements_order,
    elements_order = _ref4$elements_order === void 0 ? "icons-title" : _ref4$elements_order;
  return /*#__PURE__*/React.createElement(Link$1, {
    settings: link,
    className: s$d.card
  }, /*#__PURE__*/React.createElement("img", {
    className: s$d.image,
    src: image,
    alt: link.label
  }), /*#__PURE__*/React.createElement(TitleAndIcons, {
    title: link.label,
    icons: icons,
    order: elements_order
  }), description && /*#__PURE__*/React.createElement("div", {
    className: [s$d.description, s$d["mt-2"]].join(" ")
  }, description), tags.length > 0 && /*#__PURE__*/React.createElement(Tags, {
    list: tags,
    cardArrow: show_arrow
  }), show_arrow === "yes" && /*#__PURE__*/React.createElement(ArrowIcon, null));
}
function HighLights(_ref5) {
  var data = _ref5.data;
  return /*#__PURE__*/React.createElement("div", {
    className: s$d.highlights
  }, /*#__PURE__*/React.createElement(Desktop, null, /*#__PURE__*/React.createElement(TabsFancyTitle, {
    title: data.title
  })), /*#__PURE__*/React.createElement(Mobile, null, /*#__PURE__*/React.createElement(FancyTitle, {
    title: data.title
  })), /*#__PURE__*/React.createElement("div", {
    className: s$d.cards
  }, data.cards.map(function (card) {
    return /*#__PURE__*/React.createElement(Card, _extends({
      key: card.id
    }, card));
  })));
}
var s$f = {
  "additions": "_2NQeM",
  "card": "_1BEa_",
  "title": "_2SLr7",
  "description": "_1yxJh",
  "cards": "_2Nbn5"
};
function Card$1(_ref) {
  var icon = _ref.icon,
    link = _ref.link,
    description = _ref.description;
  return /*#__PURE__*/React.createElement(Link$1, {
    settings: link,
    className: s$f.card
  }, icon && /*#__PURE__*/React.createElement("img", {
    src: icon,
    alt: link.label
  }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    className: s$f.title
  }, link.label), description && /*#__PURE__*/React.createElement("div", {
    className: s$f.description
  }, description)));
}
function Additions(_ref2) {
  var data = _ref2.data;
  return /*#__PURE__*/React.createElement("div", {
    className: s$f.additions
  }, /*#__PURE__*/React.createElement(Desktop, null, /*#__PURE__*/React.createElement(TabsFancyTitle, {
    title: data.title
  })), /*#__PURE__*/React.createElement(Mobile, null, /*#__PURE__*/React.createElement(FancyTitle, {
    title: data.title
  })), /*#__PURE__*/React.createElement("div", {
    className: s$f.cards
  }, data.cards.map(function (card) {
    return /*#__PURE__*/React.createElement(Card$1, _extends({
      key: card.id
    }, card));
  })));
}
var s$g = {
  "tabs": "_1wRJg",
  "content": "_2XiWp"
};
function Tab(_ref) {
  var highlights = _ref.highlights,
    additions = _ref.additions;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HighLights, {
    data: highlights
  }), /*#__PURE__*/React.createElement(Additions, {
    data: additions
  }));
}
function DesktopTabs(_ref2) {
  var _tabs$;
  var tabs = _ref2.tabs,
    spacing = _ref2.spacing;
  var _React$useState = React.useState((_tabs$ = tabs[0]) === null || _tabs$ === void 0 ? void 0 : _tabs$.id),
    active = _React$useState[0],
    setActive = _React$useState[1];
  var activeTab = tabs.find(function (t) {
    return t.id === active;
  });
  return /*#__PURE__*/React.createElement(Spacing$1, {
    value: spacing
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: s$g.tabs
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(TabsFancyTitle, {
    title: "Invisible",
    invisible: true
  }), /*#__PURE__*/React.createElement(Switcher, {
    tabs: tabs,
    active: active,
    setActive: setActive
  })), /*#__PURE__*/React.createElement("div", {
    className: s$g.content
  }, /*#__PURE__*/React.createElement(Tab, activeTab)))));
}
function MobileTabs(_ref3) {
  var tabs = _ref3.tabs,
    mobile_links = _ref3.mobile_links;
  var _React$useState2 = React.useState(null),
    active = _React$useState2[0],
    _setActive = _React$useState2[1];
  var activeTab = tabs.find(function (t) {
    return t.id === active;
  });
  return /*#__PURE__*/React.createElement("div", {
    className: s$g.tabs
  }, /*#__PURE__*/React.createElement(Switcher, {
    links: mobile_links,
    tabs: tabs,
    active: active,
    setActive: function setActive(newId) {
      if (newId === active) {
        _setActive(null);
      } else {
        _setActive(newId);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: s$g.content
  }, /*#__PURE__*/React.createElement(Tab, activeTab))));
}
function Tabs(props) {
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Desktop, null, /*#__PURE__*/React.createElement(DesktopTabs, props)), /*#__PURE__*/React.createElement(Mobile, null, /*#__PURE__*/React.createElement(MobileTabs, props)));
}
var WIDGETS = {
  Title: Title,
  HTML: HTML,
  Links: Links,
  Image: Image,
  Banner: Banner,
  Tabs: Tabs
};
var ClickAway = function ClickAway(_ref) {
  var children = _ref.children,
    onAwayClick = _ref.onAwayClick;
  var wrapperRef = React.useRef(null);
  React.useEffect(function () {
    var handleClickAway = function handleClickAway(event) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        onAwayClick();
      }
    };
    document.addEventListener("mousedown", handleClickAway);
    return function () {
      document.removeEventListener("mousedown", handleClickAway);
    };
  }, [wrapperRef]);
  return /*#__PURE__*/React.createElement("div", {
    ref: wrapperRef
  }, children);
};
var SLIM_ICONS = {
  globe: {
    type: "svg",
    height: "16px",
    width: "16px",
    icon: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
      width: "16",
      height: "16",
      viewBox: "0 0 20 20",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10 19C14.9706 19 19 14.9706 19 10C19 5.02944 14.9706 1 10 1C5.02944 1 1 5.02944 1 10C1 14.9706 5.02944 19 10 19Z",
      stroke: "#1C1C1C",
      strokeWidth: "1.3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M1 10H19",
      stroke: "#1C1C1C",
      strokeWidth: "1.3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M10.0004 1C12.2515 3.46452 13.5309 6.66283 13.6004 10C13.5309 13.3372 12.2515 16.5355 10.0004 19C7.74924 16.5355 6.46991 13.3372 6.40039 10C6.46991 6.66283 7.74924 3.46452 10.0004 1V1Z",
      stroke: "#1C1C1C",
      strokeWidth: "1.3",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })))
  },
  user: {
    type: "svg",
    height: "16px",
    width: "15px",
    icon: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
      width: "15",
      height: "16",
      viewBox: "0 0 15 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/React.createElement("g", {
      clipPath: "url(#clip0)"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M7.50122 1.33588C7.03108 1.31808 6.56218 1.39532 6.12258 1.56296C5.68298 1.73061 5.28172 1.98521 4.94281 2.31154C4.6039 2.63787 4.3343 3.02921 4.15015 3.46216C3.96601 3.8951 3.87109 4.36075 3.87109 4.83123C3.87109 5.30171 3.96601 5.76735 4.15015 6.20029C4.3343 6.63324 4.6039 7.02458 4.94281 7.35091C5.28172 7.67724 5.68298 7.93184 6.12258 8.09949C6.56218 8.26713 7.03108 8.34437 7.50122 8.32657C7.97136 8.34437 8.44026 8.26713 8.87986 8.09949C9.31946 7.93184 9.72072 7.67724 10.0596 7.35091C10.3985 7.02458 10.6681 6.63324 10.8523 6.20029C11.0364 5.76735 11.1313 5.30171 11.1313 4.83123C11.1313 4.36075 11.0364 3.8951 10.8523 3.46216C10.6681 3.02921 10.3985 2.63787 10.0596 2.31154C9.72072 1.98521 9.31946 1.73061 8.87986 1.56296C8.44026 1.39532 7.97136 1.31808 7.50122 1.33588V1.33588Z",
      stroke: "#1C1C1C",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M13.4865 14.6667V14.3114C13.4865 10.9937 10.7693 8.32654 7.5016 8.32654C4.23394 8.32654 1.51672 10.9687 1.51672 14.2864V14.6367",
      stroke: "#1C1C1C",
      strokeMiterlimit: "10",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
      id: "clip0"
    }, /*#__PURE__*/React.createElement("rect", {
      width: "15",
      height: "15",
      fill: "white",
      transform: "translate(0 0.5)"
    })))))
  },
  help: {
    type: "b64",
    icon: "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyNS4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iTGF5ZXJfMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiDQoJIHdpZHRoPSIxNXB4IiBoZWlnaHQ9IjE2cHgiIHZpZXdCb3g9IjAgMCAxNSAxNiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTUgMTY7IiB4bWw6c3BhY2U9InByZXNlcnZlIj4NCjxzdHlsZSB0eXBlPSJ0ZXh0L2NzcyI+DQoJLnN0MHtmaWxsOm5vbmU7c3Ryb2tlOiMxQzFDMUM7c3Ryb2tlLWxpbmVjYXA6cm91bmQ7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO30NCgkuc3Qxe2ZpbGw6IzFDMUMxQzt9DQoJLnN0MntmaWxsOm5vbmU7c3Ryb2tlOiMxQzFDMUM7c3Ryb2tlLWxpbmVqb2luOnJvdW5kO30NCjwvc3R5bGU+DQo8Zz4NCgk8Y2lyY2xlIGNsYXNzPSJzdDAiIGN4PSI3LjUiIGN5PSI4IiByPSI2LjIiLz4NCgk8Y2lyY2xlIGNsYXNzPSJzdDEiIGN4PSI3LjUiIGN5PSIxMS40IiByPSIwLjYiLz4NCgk8cGF0aCBjbGFzcz0ic3QyIiBkPSJNNi4zLDQuOWMxLjEtMC41LDIuNi0wLjQsMy4xLDAuNEM5LjksNi4xLDkuNSw3LDguNyw3LjdTNy41LDguOSw3LjUsOS40Ii8+DQo8L2c+DQo8L3N2Zz4NCg=="
  },
  forum: {
    type: "b64",
    icon: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjc0OTggNy4zNzVDMTMuNzQ5OCAxMC40ODE2IDExLjIzMTQgMTMgOC4xMjQ4MiAxM0M3LjI2OTA5IDEzIDYuNDU3OTkgMTIuODA4OSA1LjczMTg2IDEyLjQ2NzFDNC4yNjc2MSAxMy4xNzcgMi44MzEyNiAxMy44MDY4IDEuMjA1NTcgMTQuMjk0NEMxLjY5MzE0IDEyLjY2ODcgMi4zMjI5NSAxMS4yMzI0IDMuMDMyODUgOS43NjgyQzIuNjkwOTUgOS4wNDIwMSAyLjQ5OTgyIDguMjMwODMgMi40OTk4MiA3LjM3NUMyLjQ5OTgyIDQuMjY4NCA1LjAxODIxIDEuNzUgOC4xMjQ4MiAxLjc1QzExLjIzMTQgMS43NSAxMy43NDk4IDQuMjY4NCAxMy43NDk4IDcuMzc1WiIgc3Ryb2tlPSIjMUMxQzFDIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="
  },
  downloads: {
    type: "b64",
    icon: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNSAxNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEuODc1IDkuODc1VjEzLjYyNUgxMy4xMjVWOS44NzUiIHN0cm9rZT0iIzFDMUMxQyIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik00LjM3NSA2Ljc1TDcuNSA5Ljg3NUwxMC42MjUgNi43NSIgc3Ryb2tlPSIjMUMxQzFDIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPHBhdGggZD0iTTcuNSA5Ljg3NVYyLjM3NSIgc3Ryb2tlPSIjMUMxQzFDIiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="
  },
  mobileUser: {
    type: "b64",
    icon: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTUiIGhlaWdodD0iMTUiIHZpZXdCb3g9IjAgMCAxNSAxNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzLjkzNDMgMTMuMDEyNkMxMy41ODI1IDEyLjIyMzkgMTMuMDY2OSAxMS41MDc0IDEyLjQxNjkgMTAuOTAzOEMxMS43NjY5IDEwLjMwMDIgMTAuOTk1MiA5LjgyMTQ0IDEwLjE0NTkgOS40OTQ3OEM5LjI5NjY2IDkuMTY4MTMgOC4zODY0MSA5IDcuNDY3MTYgOUM2LjU0NzkgOSA1LjYzNzY1IDkuMTY4MTMgNC43ODgzNyA5LjQ5NDc4QzMuOTM5MDkgOS44MjE0NCAzLjE2NzQyIDEwLjMwMDIgMi41MTc0MSAxMC45MDM4QzEuODY3NCAxMS41MDc0IDEuMzUxNzggMTIuMjIzOSAxIDEzLjAxMjYiIHN0cm9rZT0iYmxhY2siIHN0cm9rZS13aWR0aD0iMS41Ii8+CjxjaXJjbGUgY3g9IjcuNDY3MjkiIGN5PSI1IiByPSI0IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjEuNSIvPgo8L3N2Zz4K"
  },
  check: {
    type: "b64",
    icon: "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTQiIGhlaWdodD0iMTEiIHZpZXdCb3g9IjAgMCAxNCAxMSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTEzIDEuNUw0Ljc1IDkuNzVMMSA2IiBzdHJva2U9IiMwREI1RkYiIHN0cm9rZS13aWR0aD0iMS41IiBzdHJva2UtbGluZWNhcD0icm91bmQiIHN0cm9rZS1saW5lam9pbj0icm91bmQiLz4KPC9zdmc+Cg=="
  }
};
var ls = {
  "header": "_1Op28",
  "logo": "_3yAKW",
  "content": "_3nA-z",
  "slim-wrapper": "_TSKZm",
  "actions": "_1ngXz",
  "navigation-wrapper": "_1c53G",
  "search-toggle": "_3h6X9",
  "slim": "_1gpeH",
  "slim-item": "_3_FOQ",
  "slim-item-last": "_162SN",
  "inner-slim-item": "_33LgF",
  "sub": "_1tzMP",
  "slim-icon": "_25LKX",
  "current-language": "_1XEp2",
  "current-language-wrapper": "_3PKbb",
  "language-wrapper": "_2kOAU",
  "buttons": "_zLg_v",
  "nav-item": "_3dvdQ",
  "has-submenu": "_W5mty",
  "nav-sub": "_3ScFZ",
  "nav-cols": "_1t9Us",
  "user-sub": "_ASqNP",
  "user-header": "_HxuU2",
  "email": "_1xpYp",
  "user-avatar": "_a8HbK",
  "fake-user-avatar": "_h2QXa",
  "user-inner-menu": "_30iVM",
  "hidden": "_1JIpQ",
  "user-logout": "_2DdL-",
  "user-logout-primary": "_3Kob6",
  "user-logout-secondary": "_2rQBu",
  "desktop": "_KeCMk",
  "laptop": "_1eCOF",
  "nav": "_10wjH",
  "mobile-actions": "_1thRk",
  "open": "_yV3Nz",
  "user-mobile": "_2x76t",
  "submenu-open": "_K6w84",
  "link-wrapper": "_2xJ_g",
  "main-cta": "_r97iD",
  "mobile-nav": "_1jAaX",
  "user-toggle": "_sgK0X",
  "user-mobile-menu": "_bPvO8",
  "user-mobile-link": "_1di9a",
  "header-langs": "_20T7G",
  "active": "_ZB23k"
};
var RED_LOGO = "data:image/svg+xml;base64,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";
var BLACK_LOGO = "data:image/svg+xml;base64,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";
var Widgets = function Widgets(_ref) {
  var widgets = _ref.widgets,
    colIdx = _ref.colIdx;
  return /*#__PURE__*/React.createElement("div", {
    "data-overrides": colIdx
  }, widgets.map(function (w) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: w.id
    }, /*#__PURE__*/React.createElement(WIDGETS[w.component], w.settings));
  }));
};
var SlimIcon = function SlimIcon(_ref2) {
  var name = _ref2.name;
  var icon = SLIM_ICONS[name];
  if (icon.type === "b64") {
    return /*#__PURE__*/React.createElement("span", {
      className: ls["slim-icon"]
    }, /*#__PURE__*/React.createElement("img", {
      src: icon.icon
    }));
  }
  if (icon.type === "svg") {
    return /*#__PURE__*/React.createElement("span", {
      className: ls["slim-icon"],
      style: {
        height: icon.height,
        width: icon.width
      }
    }, icon.icon);
  }
  throw "Unknown icon format!";
};
var Item = function Item(_ref3) {
  var item = _ref3.item;
  return /*#__PURE__*/React.createElement("a", {
    href: item.url,
    className: ls["nav-item"],
    id: item.id
  }, /*#__PURE__*/React.createElement("strong", null, item.label));
};
function shouldSkipContainer(row) {
  var _row$columns;
  var skip = false;
  (_row$columns = row.columns) === null || _row$columns === void 0 ? void 0 : _row$columns.forEach(function (col) {
    var _col$widgets;
    (_col$widgets = col.widgets) === null || _col$widgets === void 0 ? void 0 : _col$widgets.forEach(function (w) {
      if (w.component === "Tabs") {
        skip = true;
      }
    });
  });
  return skip;
}
var SubMenu = function SubMenu(_ref4) {
  var menuIdx = _ref4.menuIdx,
    item = _ref4.item;
  var _React$useState = React.useState(false),
    open = _React$useState[0],
    setNavigation = _React$useState[1];
  return /*#__PURE__*/React.createElement("span", {
    href: "#",
    className: ls["nav-item"] + " " + ls["has-submenu"] + " " + (open ? ls["submenu-open"] : "")
  }, /*#__PURE__*/React.createElement("strong", {
    onClick: function onClick() {
      return setNavigation(!open);
    }
  }, item.label), /*#__PURE__*/React.createElement("div", {
    className: ls["nav-sub"]
  }, item.rows.map(function (row, rowIdx) {
    var skipContainer = shouldSkipContainer(row);
    var ContainerComponent = skipContainer ? "div" : Container;
    return /*#__PURE__*/React.createElement("div", {
      key: row.id,
      className: ls["nav-cols-wrapper"],
      "data-overrides": "menu-" + menuIdx + "-container-wrapper-" + rowIdx
    }, /*#__PURE__*/React.createElement(ContainerComponent, {
      "data-overrides": "menu-" + menuIdx + "-container-" + rowIdx
    }, /*#__PURE__*/React.createElement("div", {
      className: ls["nav-cols"],
      "data-overrides": "menu-" + menuIdx + "-row-" + rowIdx
    }, row.columns.map(function (col, colIdx) {
      return /*#__PURE__*/React.createElement(Widgets, {
        key: col.id,
        widgets: col.widgets,
        colIdx: "menu-" + menuIdx + "-row-" + rowIdx + "-col-" + colIdx
      });
    }))));
  })));
};
var Logo = function Logo(_ref5) {
  var currentLanguage = _ref5.currentLanguage,
    overwrite = _ref5.overwrite;
  if (overwrite) {
    return /*#__PURE__*/React.createElement("a", {
      href: "https://www.chaos.com/" + currentLanguage
    }, /*#__PURE__*/React.createElement("img", {
      src: BLACK_LOGO,
      className: ls.logo,
      alt: "Chaos"
    }));
  } else {
    return /*#__PURE__*/React.createElement("a", {
      href: "https://www.chaos.com/" + currentLanguage
    }, /*#__PURE__*/React.createElement("img", {
      src: RED_LOGO,
      className: ls.logo,
      alt: "Chaos"
    }));
  }
};
var UserLogoutButton = function UserLogoutButton(_ref6) {
  var logOutButton = _ref6.logOutButton;
  return logOutButton && /*#__PURE__*/React.createElement("div", {
    className: ls["user-logout"] + " " + ls["user-logout-" + logOutButton.type]
  }, /*#__PURE__*/React.createElement(SimpleButton, {
    settings: logOutButton
  }));
};
var MobileNav = function MobileNav(_ref7) {
  var languages = _ref7.languages,
    onChangeLanguage = _ref7.onChangeLanguage;
  return /*#__PURE__*/React.createElement("div", {
    className: ls["mobile-nav"]
  }, /*#__PURE__*/React.createElement("div", {
    className: ls["header-langs"]
  }, /*#__PURE__*/React.createElement("div", {
    className: ls["link-wrapper"]
  }, languages.map(function (lang) {
    return /*#__PURE__*/React.createElement("a", {
      key: lang.code,
      href: lang.link,
      onClick: onChangeLanguage ? function (event) {
        event.preventDefault();
        onChangeLanguage(lang.code, lang.link);
      } : null
    }, lang.code);
  }))));
};
var Navigation = function Navigation(_ref8) {
  var menu = _ref8.menu,
    languages = _ref8.languages,
    onChangeLanguage = _ref8.onChangeLanguage;
  return /*#__PURE__*/React.createElement("div", {
    className: ls.nav
  }, menu.map(function (item, idx) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: idx
    }, item.rows.length > 0 && /*#__PURE__*/React.createElement(SubMenu, {
      menuIdx: idx,
      key: item.id,
      item: item
    }), item.rows.length === 0 && /*#__PURE__*/React.createElement(Item, {
      key: item.id,
      item: item
    }));
  }), /*#__PURE__*/React.createElement(MobileNav, {
    languages: languages,
    onChangeLanguage: onChangeLanguage
  }));
};
var LanguageLink = function LanguageLink(_ref9) {
  var lang = _ref9.lang,
    onChangeLanguage = _ref9.onChangeLanguage,
    afterChange = _ref9.afterChange;
  return /*#__PURE__*/React.createElement("a", {
    href: lang.link,
    onClick: onChangeLanguage ? function (event) {
      event.preventDefault();
      onChangeLanguage(lang.code, lang.link);
      afterChange();
    } : null
  }, lang.label);
};
var LanguageSwitcher = function LanguageSwitcher(_ref10) {
  var showLanguages = _ref10.showLanguages,
    currentLanguage = _ref10.currentLanguage,
    languages = _ref10.languages,
    onChangeLanguage = _ref10.onChangeLanguage;
  var _React$useState2 = React.useState(false),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, showLanguages !== false && /*#__PURE__*/React.createElement("span", {
    className: ls["slim-item"] + " " + ls["sub-menu"]
  }, /*#__PURE__*/React.createElement(ClickAway, {
    onAwayClick: function onAwayClick() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React.createElement("span", {
    className: ls["inner-slim-item"],
    onClick: function onClick() {
      return setOpen(!open);
    }
  }, /*#__PURE__*/React.createElement(SlimIcon, {
    name: "globe"
  }), /*#__PURE__*/React.createElement("span", {
    className: ls["current-language"]
  }, currentLanguage)), open && /*#__PURE__*/React.createElement("div", {
    className: ls.sub
  }, languages.map(function (lang) {
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: lang.code
    }, lang.code.toLowerCase() === currentLanguage.toLowerCase() && /*#__PURE__*/React.createElement("div", {
      className: ls["current-language-wrapper"]
    }, /*#__PURE__*/React.createElement(SlimIcon, {
      name: "check"
    }), /*#__PURE__*/React.createElement(LanguageLink, {
      lang: lang,
      onChangeLanguage: onChangeLanguage,
      afterChange: function afterChange() {
        return setOpen(false);
      }
    })), lang.code.toLowerCase() !== currentLanguage.toLowerCase() && /*#__PURE__*/React.createElement("div", {
      className: ls["language-wrapper"]
    }, /*#__PURE__*/React.createElement(LanguageLink, {
      lang: lang,
      onChangeLanguage: onChangeLanguage,
      afterChange: function afterChange() {
        return setOpen(false);
      }
    })));
  })))));
};
var linkDecorator = function linkDecorator(link, returnUrl) {
  return link && link.replace("RETURN_URL", returnUrl);
};
var prepAccountMenu = function prepAccountMenu(menu, returnUrl) {
  return menu.map(function (e) {
    return {
      link: _extends({}, e.link, {
        link: linkDecorator(e.link.link, returnUrl)
      }),
      icon: _extends({}, e.icon)
    };
  });
};
var Icon$1 = function Icon(_ref11) {
  var src = _ref11.src;
  return /*#__PURE__*/React.createElement("div", {
    className: ls.icon
  }, src && src.urls && src.urls.original && /*#__PURE__*/React.createElement("img", {
    src: src.urls.original,
    alt: src.title
  }));
};
var extractAvatarContent = function extractAvatarContent(user) {
  if (!user || !user.fullName) {
    return "";
  }
  var _user$fullName$split = user.fullName.split(" "),
    first = _user$fullName$split[0],
    last = _user$fullName$split[1];
  return "" + (first && first[0]) + (last && last[0]);
};
var UserMenu = function UserMenu(_ref12) {
  var user = _ref12.user,
    signInLink = _ref12.signInLink,
    returnUrl = _ref12.returnUrl,
    accountMenu = _ref12.accountMenu,
    logOutButton = _ref12.logOutButton;
  var _React$useState3 = React.useState(false),
    open = _React$useState3[0],
    setOpen = _React$useState3[1];
  return /*#__PURE__*/React.createElement(React.Fragment, null, user && /*#__PURE__*/React.createElement("span", {
    className: ls["slim-item"] + " " + ls["sub-menu"]
  }, /*#__PURE__*/React.createElement(ClickAway, {
    onAwayClick: function onAwayClick() {
      return setOpen(false);
    }
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick() {
      return setOpen(!open);
    },
    className: ls["user-avatar"]
  }, extractAvatarContent(user)), open && /*#__PURE__*/React.createElement("div", {
    className: ls.sub + " " + ls["user-sub"]
  }, /*#__PURE__*/React.createElement("div", {
    className: ls["user-header"]
  }, /*#__PURE__*/React.createElement("h5", null, user.fullName), /*#__PURE__*/React.createElement("div", {
    className: ls.email
  }, user.email)), /*#__PURE__*/React.createElement("div", {
    className: ls["user-inner-menu"]
  }, prepAccountMenu(accountMenu, returnUrl).map(function (_ref13, idx) {
    var link = _ref13.link,
      icon = _ref13.icon;
    return /*#__PURE__*/React.createElement("a", {
      key: idx,
      href: link.link,
      id: link.id,
      className: ls[link.className]
    }, /*#__PURE__*/React.createElement(Icon$1, {
      src: icon
    }), link.label);
  })), /*#__PURE__*/React.createElement(UserLogoutButton, {
    logOutButton: Object.assign(logOutButton, {
      link: linkDecorator(logOutButton && logOutButton.link, returnUrl)
    })
  })))), !user && signInLink && /*#__PURE__*/React.createElement("a", {
    key: signInLink.id,
    href: linkDecorator(signInLink.link, returnUrl),
    className: ls["slim-item"] + " " + ls["fake-user-avatar"],
    id: signInLink.id
  }, /*#__PURE__*/React.createElement("span", {
    className: ls["inner-slim-item"]
  }, /*#__PURE__*/React.createElement(SlimIcon, {
    name: "user"
  }), /*#__PURE__*/React.createElement("span", null, signInLink.label))));
};
var UserMenuMobile = function UserMenuMobile(_ref14) {
  var user = _ref14.user,
    signInLink = _ref14.signInLink,
    returnUrl = _ref14.returnUrl,
    accountMenu = _ref14.accountMenu,
    logOutButton = _ref14.logOutButton,
    open = _ref14.open,
    onToggle = _ref14.onToggle;
  return /*#__PURE__*/React.createElement("div", {
    className: ls["user-mobile"]
  }, user && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: ls["user-toggle"],
    onClick: function onClick() {
      return onToggle(!open);
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: ls["user-avatar"]
  }, extractAvatarContent(user))), open && /*#__PURE__*/React.createElement("div", {
    className: ls["user-mobile-menu"]
  }, /*#__PURE__*/React.createElement(ButonClose, {
    onClick: function onClick() {
      return onToggle(false);
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: ls["user-header"]
  }, /*#__PURE__*/React.createElement("h4", null, user.fullName), /*#__PURE__*/React.createElement("div", {
    className: ls.email
  }, user.email)), /*#__PURE__*/React.createElement("div", {
    className: ls["user-inner-menu"]
  }, prepAccountMenu(accountMenu).map(function (_ref15, idx) {
    var link = _ref15.link,
      icon = _ref15.icon;
    return /*#__PURE__*/React.createElement("a", {
      key: idx,
      href: link.link,
      className: ls["user-mobile-link"] + " " + ls[link.className],
      id: link.id
    }, /*#__PURE__*/React.createElement(Icon$1, {
      src: icon
    }), /*#__PURE__*/React.createElement("span", null, link.label));
  })), /*#__PURE__*/React.createElement(UserLogoutButton, {
    logOutButton: Object.assign(logOutButton, {
      link: linkDecorator(logOutButton && logOutButton.link, returnUrl)
    })
  }))), !user && signInLink && /*#__PURE__*/React.createElement("a", {
    key: signInLink.id,
    href: linkDecorator(signInLink.link, returnUrl),
    className: ls["user-toggle"]
  }, /*#__PURE__*/React.createElement(SlimIcon, {
    name: "mobileUser"
  })));
};
var SlimNavItems = function SlimNavItems(_ref16) {
  var slimNavigation = _ref16.slimNavigation;
  return slimNavigation.map(function (nav, idx) {
    return /*#__PURE__*/React.createElement("a", {
      key: nav.id,
      className: idx === slimNavigation.length - 1 ? ls["slim-item-last"] + " " + ls["slim-item"] : ls["slim-item"],
      href: nav.link.link
    }, /*#__PURE__*/React.createElement("span", {
      className: ls["inner-slim-item"]
    }, nav.icon && /*#__PURE__*/React.createElement("span", {
      className: ls["slim-icon"]
    }, /*#__PURE__*/React.createElement("img", {
      src: nav.icon.urls.original
    })), /*#__PURE__*/React.createElement("span", null, nav.link.label)));
  });
};
var SlimNavigation = function SlimNavigation(_ref17) {
  var laguageSwitcher = _ref17.laguageSwitcher,
    userMenu = _ref17.userMenu,
    slimNavigation = _ref17.slimNavigation;
  var cart = React.useContext(CartContext);
  return /*#__PURE__*/React.createElement("div", {
    className: ls.slim
  }, slimNavigation && slimNavigation.length > 0 && /*#__PURE__*/React.createElement(SlimNavItems, {
    slimNavigation: slimNavigation
  }), cart && cart.component && cart.component(), /*#__PURE__*/React.createElement(LanguageSwitcher, laguageSwitcher), /*#__PURE__*/React.createElement(UserMenu, userMenu));
};
var Buttons = function Buttons(_ref18) {
  var button_1 = _ref18.button_1,
    button_2 = _ref18.button_2,
    button_1_items = _ref18.button_1_items,
    button_2_items = _ref18.button_2_items;
  return /*#__PURE__*/React.createElement("div", {
    className: ls.buttons
  }, /*#__PURE__*/React.createElement(Button, {
    settings: button_1,
    menu: button_1_items
  }), /*#__PURE__*/React.createElement(Button, {
    settings: button_2,
    menu: button_2_items
  }));
};
var SearchToggle = function SearchToggle(_ref19) {
  var onClick = _ref19.onClick;
  return /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: ls["search-toggle"],
    onClick: onClick
  }, "Search");
};
var searchVisible = function searchVisible(_ref20) {
  var search = _ref20.search;
  return search && search.enabled && search.visible;
};
function Header(_ref21) {
  var data = _ref21.data,
    user = _ref21.user,
    returnUrl = _ref21.returnUrl,
    showLanguages = _ref21.showLanguages,
    currentLanguage = _ref21.currentLanguage,
    languages = _ref21.languages,
    cart = _ref21.cart,
    onChangeLanguage = _ref21.onChangeLanguage;
  var _React$useState4 = React.useState(false),
    navigation = _React$useState4[0],
    setNavigation = _React$useState4[1];
  var _React$useState5 = React.useState(false),
    profile = _React$useState5[0],
    setProfile = _React$useState5[1];
  var _React$useState6 = React.useState(false),
    search = _React$useState6[0],
    setSearch = _React$useState6[1];
  var handleOpenSearch = function handleOpenSearch() {
    return setSearch(true);
  };
  var handleCloseSearch = function handleCloseSearch() {
    return setSearch(false);
  };
  return /*#__PURE__*/React.createElement(CartContext.Provider, {
    value: cart
  }, /*#__PURE__*/React.createElement("div", {
    className: ls.header + " " + (navigation ? ls.open : "") + " " + (profile ? ls["profile-open"] : "")
  }, /*#__PURE__*/React.createElement(Logo, {
    currentLanguage: currentLanguage,
    overwrite: data.overwrite_logo
  }), /*#__PURE__*/React.createElement("div", {
    className: ls.content
  }, /*#__PURE__*/React.createElement("nav", null, /*#__PURE__*/React.createElement("div", {
    className: ls["slim-wrapper"]
  }, /*#__PURE__*/React.createElement(SlimNavigation, {
    slimNavigation: data.slim_navigation,
    laguageSwitcher: {
      currentLanguage: currentLanguage,
      languages: languages,
      onChangeLanguage: onChangeLanguage,
      showLanguages: showLanguages
    },
    userMenu: {
      user: user,
      returnUrl: returnUrl,
      signInLink: data.sign_in_link,
      accountMenu: data.account_menu,
      logOutButton: data.account_menu_logout_button
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: ls.actions
  }, /*#__PURE__*/React.createElement("div", {
    className: ls["navigation-wrapper"]
  }, /*#__PURE__*/React.createElement(Navigation, {
    menu: data.mega_menu,
    languages: languages,
    onChangeLanguage: onChangeLanguage
  }), searchVisible(data) && /*#__PURE__*/React.createElement(SearchToggle, {
    onClick: handleOpenSearch
  }, "Search")), /*#__PURE__*/React.createElement(Buttons, {
    button_1: data.button_1,
    button_2: data.button_2,
    button_1_items: data.button_1_items,
    button_2_items: data.button_2_items
  }), /*#__PURE__*/React.createElement("div", {
    className: ls["mobile-actions"]
  }, cart && cart.component && cart.component(), /*#__PURE__*/React.createElement(UserMenuMobile, {
    user: user,
    returnUrl: returnUrl,
    signInLink: data.sign_in_link,
    accountMenu: data.account_menu,
    logOutButton: data.account_menu_logout_button,
    open: profile,
    onToggle: setProfile
  }), searchVisible(data) && /*#__PURE__*/React.createElement(SearchToggle, {
    onClick: handleOpenSearch
  }, "Search"), /*#__PURE__*/React.createElement(Hamburger, {
    open: navigation,
    onClick: function onClick() {
      if (profile) setProfile(false);else setNavigation(!navigation);
    }
  }))))), searchVisible(data) && /*#__PURE__*/React.createElement(Search, {
    visible: search,
    onClose: handleCloseSearch,
    search: data.search
  })));
}
var s$h = {
  "hstack": "_28cEx",
  "content": "_3qpOK"
};
var s$i = {
  "rect": "_aKuiG",
  "load": "_2V5mj"
};
var Rectangle = function Rectangle(_ref) {
  var props = _extends({}, _ref);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: s$i.rect
  }, props));
};
var LOGO = "data:image/svg+xml;base64,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";
var HeaderPlaceholder = function HeaderPlaceholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: ls.header
  }, /*#__PURE__*/React.createElement("img", {
    src: LOGO,
    className: ls.logo,
    alt: "Chaos"
  }), /*#__PURE__*/React.createElement("div", {
    className: ls.content + " " + s$h.content
  }, /*#__PURE__*/React.createElement("div", {
    className: ls["slim-wrapper"]
  }, /*#__PURE__*/React.createElement("div", {
    className: ls.slim,
    style: {
      padding: "0.5em 0",
      marginRight: "1em"
    }
  }, /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "50px",
      height: "1.5em"
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "50px",
      height: "1.5em"
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "50px",
      height: "1.5em"
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "50px",
      height: "1.5em"
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "25px",
      height: "1.5em"
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: ls.actions
  }, /*#__PURE__*/React.createElement("div", {
    className: ls["navigation-wrapper"]
  }, /*#__PURE__*/React.createElement("div", {
    className: s$h.hstack,
    style: {
      padding: "0.75em 0"
    }
  }, /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "100px",
      height: "2em"
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "100px",
      height: "2em"
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "100px",
      height: "2em"
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "100px",
      height: "2em"
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "100px",
      height: "2em"
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "100px",
      height: "2em"
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "100px",
      height: "2em"
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "100px",
      height: "2em"
    }
  }))), /*#__PURE__*/React.createElement("div", {
    className: ls.buttons
  }, /*#__PURE__*/React.createElement("div", {
    className: s$h.hstack
  }, /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "75px",
      height: "2em"
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "75px",
      height: "2em"
    }
  }))))));
};
var index = withApiData(withOptimize(withMegaMenu(Header), HeaderPlaceholder), HeaderPlaceholder);
var fs = {
  "footer": "_1AXXX",
  "links": "_2k1Cu",
  "social": "_3W-Pq"
};
var s$j = {
  "wrappable-flex-container": "_3_GJ9",
  "fixed-flex-item": "_3iFwP",
  "flex-container": "_MpMpv",
  "flex-item": "_1v3PJ"
};
function FlexItem(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/React.createElement("div", {
    className: s$j["flex-item"]
  }, children);
}
function FlexContainer(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/React.createElement("div", {
    className: s$j["flex-container"]
  }, children);
}
function FixedFlexItem(_ref3) {
  var children = _ref3.children;
  return /*#__PURE__*/React.createElement("div", {
    className: s$j["fixed-flex-item"]
  }, children);
}
function WrappableFlexContainer(_ref4) {
  var children = _ref4.children;
  return /*#__PURE__*/React.createElement("div", {
    className: s$j["wrappable-flex-container"]
  }, children);
}
var s$k = {
  "slim-wrapper": "_3IW27",
  "products": "_3iKUt",
  "logos-wrapper": "_3Bfk7",
  "slim": "_1QqU4"
};
var LOGO$1 = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4KPCEtLSBHZW5lcmF0b3I6IEFkb2JlIElsbHVzdHJhdG9yIDI3LjcuMCwgU1ZHIEV4cG9ydCBQbHVnLUluIC4gU1ZHIFZlcnNpb246IDYuMDAgQnVpbGQgMCkgIC0tPgo8c3ZnIHZlcnNpb249IjEuMSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczp4bGluaz0iaHR0cDovL3d3dy53My5vcmcvMTk5OS94bGluayIgeD0iMHB4IiB5PSIwcHgiIHdpZHRoPSIxMDBweCIKCSBoZWlnaHQ9IjEwMHB4IiB2aWV3Qm94PSIwIDAgMTAwIDEwMCIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgMTAwIDEwMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPgo8ZyBpZD0iTGF5ZXJfMSI+Cgk8Zz4KCQk8cGF0aCBzdHlsZT0iZmlsbDojRTExNjFDOyIgZD0iTTAsMTAwaDEwMFYwSDBWMTAweiIvPgoJCTxnPgoJCQk8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTg2LjA4MDc0OTUsNTguMzMzMzEzYzMuMzk2NjA2NCwwLDYuODM1OTM3NS0xLjg2NTk2NjgsNi44MzU5Mzc1LTUuNDMzMjI3NQoJCQkJYzAtMi43MTUxNDg5LTIuNTEzNzkzOS00LjE5OTQ2MjktNS4wMDQ0NTU2LTQuNDY2Njc0OGMtMS45NDE5NTU2LTAuMjE5ODQ4Ni0zLjU4MzMxMy0wLjk2MDkzNzUtMy41ODMzMTMtMS42MTYxNDk5CgkJCQljMC0xLjAxMTg0MDgsMS4wOTY4MDE4LTEuMTYyNTk3NywxLjc1MTgzMTEtMS4xNjI1OTc3YzAuNjE5MzIzNywwLDIuMDYyMTMzOCwwLjE0MDk5MTIsMi4wNjIxMzM4LDEuNDQ1OTIyOQoJCQkJYzAsMC4xMTIzMDQ3LDAuMDgyNTE5NSwwLjIwMzA2NCwwLjE4MzE2NjUsMC4yMDMwNjRoNC4yMjUwMzY2YzAuMTAxMzE4NCwwLDAuMTgzMTA1NS0wLjA5MDc1OTMsMC4xODMxMDU1LTAuMjAzMDY0CgkJCQljMC0zLjE5OTUyMzktMi43MzYwMjI5LTUuNDMzOTYtNi42NTM0NDI0LTUuNDMzOTZjLTMuODU1OTU3LDAtNi42NTQ5MDcyLDIuMjE0MjMzNC02LjY1NDkwNzIsNS4yNjM2NzE5CgkJCQljMCwyLjYzODQyNzcsMy4yOTM4ODQzLDQuNDQ1ODAwOCw2LjM5MzQzMjYsNC44MDY1Nzk2YzEuMzcyOTI0OCwwLjE3MTYzMDksMi4xOTQzMzU5LDAuODEzNjU5NywyLjE5NDMzNTksMS4zMzM0OTYxCgkJCQljMCwwLjgyODMwODEtMC45OTYxNTQ4LDEuMjc0OTAyMy0xLjkzMjg2MTMsMS4yNzQ5MDIzYy0wLjM2OTA3OTYsMC0yLjIwNjkwOTItMC4wNjk3NjMyLTIuMjA2OTA5Mi0xLjQ0NTE5MDQKCQkJCWMwLTAuMTEzMDM3MS0wLjA4MjQ1ODUtMC4yMDM3MzU0LTAuMTgzODM3OS0wLjIwMzczNTRoLTQuMjYyMDg1Yy0wLjEwMTMxODQsMC0wLjE4MzEwNTUsMC4wOTA2OTgyLTAuMTgzMTA1NSwwLjIwMzczNTQKCQkJCUM3OS4yNDQ4MTIsNTYuNDY3MzQ2Miw4Mi42ODQwODIsNTguMzMzMzEzLDg2LjA4MDc0OTUsNTguMzMzMzEzeiIvPgoJCQk8cGF0aCBzdHlsZT0iZmlsbDojRkZGRkZGOyIgZD0iTTI1LjU2MzM1NDUsNTcuODc4MDUxOGg0LjEzMjMyNDJjMC4xMTMyODEyLDAsMC4yMDQxNjI2LTAuMDkwNzU5MywwLjIwNDE2MjYtMC4yMDMxMjVWNDkuOTcwNTIKCQkJCWMwLTIuMDA3MDgwMSwxLjA0NDQzMzYtNC4wMzI5NTksMy4zNzg3MjMxLTQuMDMyOTU5YzIuMzM0MjI4NSwwLDMuMzc4NjYyMSwyLjAzOTg1NiwzLjM3ODY2MjEsNC4wNjE1ODQ1djcuNjc1NzgxMgoJCQkJYzAsMC4xMTIzNjU3LDAuMDkwODgxMywwLjIwMzEyNSwwLjIwNDE2MjYsMC4yMDMxMjVoNC4xMzI5OTU2YzAuMTExODc3NCwwLDAuMjAzNDkxMi0wLjA5MDc1OTMsMC4yMDM0OTEyLTAuMjAzMTI1di03LjY3NTc4MTIKCQkJCWMwLTQuNzUxNzctMy40MDQ2MDIxLTguMzMzOTIzMy03LjkxOTMxMTUtOC4zMzM5MjMzYy0xLjIzODgzMDYsMC0yLjM5ODYyMDYsMC4zOTIyMTE5LTMuMzc4NzIzMSwxLjEzODI0NDZWMzQuMzY5NzUxCgkJCQljMC0wLjExMjM2NTctMC4wOTA4ODEzLTAuMjAzMTI1LTAuMjA0MTYyNi0wLjIwMzEyNWgtNC4xMzIzMjQyYy0wLjExMjU0ODgsMC0wLjIwNDEwMTYsMC4wOTA3NTkzLTAuMjA0MTAxNiwwLjIwMzEyNXYyMy4zMDUxNzU4CgkJCQlDMjUuMzU5MjUyOSw1Ny43ODcyOTI1LDI1LjQ1MDgwNTcsNTcuODc4MDUxOCwyNS41NjMzNTQ1LDU3Ljg3ODA1MTh6Ii8+CgkJCTxwYXRoIHN0eWxlPSJmaWxsOiNGRkZGRkY7IiBkPSJNNTEuMTU5NjA2OSw1OC4zMzMzMTNjMS41MzQ0MjM4LDAsMy4wMzE3MzgzLTAuNzgyMjg3Niw0LjEwNTQ2ODgtMi4xMjAwNTYybDAuMDE3NTE3MSwxLjQ2NDc4MjcKCQkJCWMwLjAwMTQwMzgsMC4xMTE2MzMzLDAuMDkyMjg1MiwwLjIwMDk4ODgsMC4yMDM0MzAyLDAuMjAwOTg4OGgzLjg1Nzk3MTJjMC4xMTE4Nzc0LDAsMC4yMDI3NTg4LTAuMDkxNDMwNywwLjIwMjc1ODgtMC4yMDMwNjQKCQkJCXYtNy42NzU2NTkyYzAtNC41OTUyNzU5LTMuNzYxNTM1Ni04LjMzMzY3OTItOC4zODcxNDYtOC4zMzM2NzkyYy00LjYyMzQ3NDEsMC04LjM4NjQxMzYsMy43Mzg0MDMzLTguMzg2NDEzNiw4LjMzMzY3OTIKCQkJCUM0Mi43NzMxOTM0LDU0LjU5NDk3MDcsNDYuNTM2MTMyOCw1OC4zMzMzMTMsNTEuMTU5NjA2OSw1OC4zMzMzMTN6IE01MS4yNDI3OTc5LDQ1LjkzODg0MjgKCQkJCWMyLjE2NjMyMDgsMCwzLjkyOTMyMTMsMS44MjIwODI1LDMuOTI5MzIxMyw0LjA2MTQ2MjRjMCwyLjIzOTQ0MDktMS43NjMwMDA1LDQuMDYxNTIzNC0zLjkyOTMyMTMsNC4wNjE1MjM0CgkJCQlzLTMuOTI5MzIxMy0xLjgyMjA4MjUtMy45MjkzMjEzLTQuMDYxNTIzNEM0Ny4zMTM0NzY2LDQ3Ljc2MDkyNTMsNDkuMDc2NDc3MSw0NS45Mzg4NDI4LDUxLjI0Mjc5NzksNDUuOTM4ODQyOHoiLz4KCQkJPHBhdGggc3R5bGU9ImZpbGw6I0ZGRkZGRjsiIGQ9Ik02OS41MzcxNzA0LDU4LjMzMzMxM2M0LjYzOTUyNjQsMCw4LjQxNTEwMDEtMy43MzgzNDIzLDguNDE1MTAwMS04LjMzMzAwNzgKCQkJCWMwLTQuNTk1Mjc1OS0zLjc3NTU3MzctOC4zMzM2NzkyLTguNDE1MTAwMS04LjMzMzY3OTJzLTguNDE1MTAwMSwzLjczODQwMzMtOC40MTUxMDAxLDguMzMzNjc5MgoJCQkJQzYxLjEyMjA3MDMsNTQuNTk0OTcwNyw2NC44OTc2NDQsNTguMzMzMzEzLDY5LjUzNzE3MDQsNTguMzMzMzEzeiBNNjkuNTM3MTcwNCw0NS45Mzg4NDI4CgkJCQljMi4xMzYyOTE1LDAsMy44NzQ4MTY5LDEuODIyMDgyNSwzLjg3NDgxNjksNC4wNjE0NjI0YzAsMi4yMzk0NDA5LTEuNzM4NTI1NCw0LjA2MTUyMzQtMy44NzQ4MTY5LDQuMDYxNTIzNAoJCQkJcy0zLjg3NDA4NDUtMS44MjIwODI1LTMuODc0MDg0NS00LjA2MTUyMzRDNjUuNjYzMDg1OSw0Ny43NjA5MjUzLDY3LjQwMDg3ODksNDUuOTM4ODQyOCw2OS41MzcxNzA0LDQ1LjkzODg0Mjh6Ii8+CgkJCTxwYXRoIHN0eWxlPSJmaWxsOiNGRkZGRkY7IiBkPSJNMTguNzU0MTUwNCw1Ny42NDAxOTc4YzMuNDg1ODM5OC0xLjUxMjMyOTEsNS40MTE4MDQyLTUuMTE1MjM0NCw0Ljk0OTc2ODEtOC42OTg5MTM2CgkJCQljLTAuMDMxMDA1OS0wLjI0MzY1MjMtMC4yOTAyODMyLTAuMzg4OTE2LTAuNTE3MTUwOS0wLjI5MTEzNzdsLTMuNDg3MTgyNiwxLjUxMzY3MTkKCQkJCWMtMC4xMjQxNDU1LDAuMDU0MzgyMy0wLjIwNTUwNTQsMC4xNzE0NDc4LTAuMjIwNzAzMSwwLjMwNjMzNTRjLTAuMTY0MDYyNSwxLjM5MzI0OTUtMS4wNDQwMDYzLDIuNjY0NjcyOS0yLjQyNTkwMzMsMy4yNjQ5NTM2CgkJCQljLTIuMTQ1OTM1MSwwLjkzMTMzNTQtNC42NTQ2NjMxLTAuMTIzMjMtNS40NjU1NzYyLTIuMzUyODQ0MmMtMC43MTE2Njk5LTEuOTU5MTA2NCwwLjIxMDMyNzEtNC4xODA0ODEsMi4wOTkwNjAxLTUuMDY3MDc3NgoJCQkJYzEuNDEwODg4Ny0wLjY2MjIzMTQsMi45OTU1NDQ0LTAuNDQ4ODUyNSw0LjE1ODgxMzUsMC40MDU0NTY1YzAuMTA5NjgwMiwwLjA3OTgzNCwwLjI1MTAzNzYsMC4xMDE4Njc3LDAuMzc1MTgzMSwwLjA0NjgxNAoJCQkJbDMuNDg3MTgyNi0xLjUxMzA2MTVjMC4yMjYxMzUzLTAuMDk3NzE3MywwLjI5NjUwODgtMC4zODY4NDA4LDAuMTQwNjI1LTAuNTc1NDM5NQoJCQkJYy0yLjQwNTIxMjQtMi44OTQ1OTIzLTYuNTg4MTk1OC0zLjkxNDc5NDktMTAuMTcxOTM2LTIuMTIyOTI0OGMtMy44MjIyNjU2LDEuOTExNTYwMS01LjU4MzQ5NjEsNi40ODkxOTY4LTQuMDI5MTc0OCwxMC40NjM4NjcyCgkJCQlDOS4zNzg2NjIxLDU3LjQ0ODg1MjUsMTQuNDI3MDYzLDU5LjUxODA2NjQsMTguNzU0MTUwNCw1Ny42NDAxOTc4eiIvPgoJCTwvZz4KCTwvZz4KPC9nPgo8ZyBpZD0iSXNvbGF0aW9uX01vZGUiPgo8L2c+Cjwvc3ZnPgo=";
var CORONA = {
  id: "corona-renderer",
  htmlID: "footer-corona",
  name: "Corona renderer",
  link: "https://www.chaos.com/corona",
  target: "",
  logo: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    x: "0px",
    y: "0px",
    width: "40",
    height: "40",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F3712B",
    d: "M0,0v100h100V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M67.5859375,22.9960938c0.8706055,3.9125977-1.3916016,6.9240723-1.3916016,6.9240723 C59.46875,19.1967773,54.0185547,17.1818848,49.5439453,17.0062256c2.5986328,4.338501-0.3125,8.0899658-0.4038086,8.0753174 c-7.8774414-12.8620605-18.3105469-7.1517334-18.3105469-7.1517334s7.3686523,5.2301025,4.5258789,11.3636475 c-10.9633789-7.3326416-18.6889648,0.2874756-18.6889648,0.2874756s11.6206055,4.6218262,8.7763672,11.81604 c-2.0097656,4.6206055-7.730957,3.5612793-8.1430664,3.1965332c-0.0615234,3.2352295,1.5576172,13.3930664,11.4262695,18.7668457 c0,0-3.5234375,2.4221191-8.0488281,1.288208c0.8637695,1.7593994,1.9477539,3.5412598,3.3232422,5.2965088 C34.6655273,84.4733887,55.1870117,87.675293,69.8359375,77.095459 c14.6474609-10.5783691,17.8740234-30.9316406,7.2089844-45.4624023 C74.2822266,27.4489746,69.7783203,24.3469238,67.5859375,22.9960938z M67.2158203,71.9904785 c-8.6113281,6.2202148-20.6772461,4.3371582-26.9472656-4.2052002c-0.1835938-0.2528076-0.3378906-0.5150146-0.5097656-0.7718506 c-5.6176758-8.4798584-3.609375-19.9206543,4.7495117-25.9558105c8.4824219-6.1256104,20.3027344-4.3769531,26.6489258,3.8393555 c0.0966797,0.1251221,0.2041016,0.2368164,0.2983398,0.3659668C77.7265625,53.8039551,75.828125,65.7705078,67.2158203,71.9904785 z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  })))
};
var VRAY = {
  id: "vray",
  htmlID: "footer-vray",
  name: "V-Ray",
  link: "/vray",
  target: "",
  logo: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "#2857AF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.3168 24.2834C16.5835 24.6667 16.9002 24.8834 17.1668 24.8667C17.4835 24.8501 17.8335 24.5334 18.1002 24.0501C18.9502 22.4667 19.5001 20.9167 20.0335 19.4334C20.7835 17.3334 21.5502 15.1667 23.1002 13.1167C24.7335 10.9834 27.3168 10.1501 28.2668 9.91675C28.4168 9.88341 28.4502 9.70008 28.3335 9.60008C26.0335 7.76675 23.1502 6.66675 20.0002 6.66675C18.4501 6.66675 16.9668 6.93341 15.5835 7.41675C13.8835 8.01675 12.7335 9.61675 12.6835 11.4167C12.6335 14.9167 13.1835 19.9001 16.3168 24.2834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.7168 13.0001C27.3002 13.1834 26.2502 14.2001 25.6335 15.0167C24.3835 16.6834 23.7502 18.4334 23.0168 20.4834C22.4335 22.0834 21.8502 23.7501 20.8835 25.5501C20.0835 27.0334 18.8002 28.5501 17.3668 28.6501C17.2835 28.6501 17.2168 28.6501 17.1335 28.6501C15.8335 28.6501 14.5835 27.3501 13.7168 26.1167C10.5002 21.6001 9.60016 16.6667 9.50016 12.8501C9.50016 12.5001 9.05016 12.3834 8.85016 12.6667C6.95016 15.4334 6.06683 19.3001 7.05016 23.2001C8.30016 28.1834 12.3335 31.9334 16.9668 32.9667C25.6335 34.9167 33.3168 28.3167 33.3168 19.9667C33.3168 18.2834 33.0002 16.6834 32.4335 15.2001C32.0168 14.1167 31.1002 13.2834 29.9668 13.0334C29.5668 12.9667 29.1335 12.9501 28.7168 13.0001Z",
    fill: "white"
  })))
};
var COSMOS = {
  id: "cosmos",
  htmlID: "footer-cosmos",
  name: "Chaos Cosmos",
  link: "/cosmos",
  target: "",
  logo: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "#714AB5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 6.66675C12.6333 6.66675 6.66663 12.6334 6.66663 20.0001C6.66663 26.9334 11.9666 32.6334 18.7333 33.2668C18.7 32.9834 18.6833 32.6834 18.6833 32.4001C18.6833 28.2001 22.0833 24.8001 26.2833 24.8001C28.2833 24.8001 30.1 25.5667 31.45 26.8334C32.65 24.8334 33.3333 22.5001 33.3333 20.0167C33.3333 12.6334 27.3666 6.66675 20 6.66675ZM15.3 23.9001C12.85 23.9001 10.85 21.9167 10.85 19.4501C10.85 16.9834 12.8333 15.0001 15.3 15.0001C17.75 15.0001 19.75 16.9834 19.75 19.4501C19.75 21.9167 17.75 23.9001 15.3 23.9001ZM22.4 14.0501C21.1166 14.0501 20.0833 13.0167 20.0833 11.7334C20.0833 10.4501 21.1166 9.41675 22.4 9.41675C23.6833 9.41675 24.7166 10.4501 24.7166 11.7334C24.7 13.0167 23.6666 14.0501 22.4 14.0501Z",
    fill: "white"
  })))
};
var SCANS = {
  id: "scans",
  htmlID: "footer-scans",
  name: "Chaos Scans",
  link: "/scans",
  target: "",
  logo: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "#9E3988"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4332 26.4C23.5666 26.4167 23.6832 26.3667 23.7832 26.25L32.7999 16.25C32.6166 15.6334 32.3999 15.05 32.1333 14.4667L23.1666 25.7334C23.0166 25.9 23.0499 26.1667 23.2166 26.3C23.2832 26.3667 23.3499 26.4 23.4332 26.4Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.3338 10.4835L19.0005 25.9502C18.8672 26.1335 18.9172 26.3835 19.1005 26.5168C19.1672 26.5668 19.2505 26.6002 19.3338 26.6002C19.4672 26.6002 19.5838 26.5335 19.6672 26.4335L30.6338 11.9668C30.2505 11.4502 29.8005 10.9502 29.3338 10.4835Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.9835 26.4334L27.3002 8.85008C25.2002 7.46675 22.7002 6.66675 20.0002 6.66675C12.9335 6.66675 7.13353 12.1834 6.7002 19.1334L15.9835 26.4334Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0667 33.3333C27.3834 33.3 33.3167 27.35 33.3334 20.0167L20.0667 33.3333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.86686 22.2835C7.7502 27.4335 11.6002 31.5835 16.6002 32.9001L6.86686 22.2835Z",
    fill: "white"
  })))
};
var PHOENIX = {
  id: "phoenix",
  htmlID: "footer-phoenix",
  name: "Phoenix FD",
  link: "/phoenix",
  target: "",
  logo: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "#F3B830"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3336 19.9999C33.3336 12.4666 27.0836 6.38325 19.4836 6.68325C12.6003 6.94991 6.9836 12.5332 6.6836 19.4166C6.5336 22.6999 7.5836 25.7332 9.41693 28.1166C9.71693 28.4999 10.0669 28.4333 10.2003 27.9666C11.1669 24.6499 13.6836 21.6332 16.2836 19.7332C15.2003 18.6332 14.8669 17.5999 14.6836 15.9999C15.1336 16.5166 15.8003 17.5666 17.1169 17.5166C14.6336 15.2499 15.0003 11.6666 15.0003 11.6666C15.0003 11.6666 16.0503 14.0166 18.4669 14.5499C16.8669 12.8499 16.0669 10.6999 17.2336 8.24991C17.4669 10.3832 18.9169 11.3832 20.4836 12.7332C21.1669 13.3166 21.9169 13.8499 22.6336 14.3999C24.4836 15.8499 26.4336 17.1999 28.1503 18.7832C29.6503 20.1666 30.2503 21.9999 29.8169 24.2499C27.8503 21.6166 24.6669 21.2166 22.5669 22.2832C20.5669 23.2999 19.6169 25.7499 20.3336 28.1833C20.6169 29.1333 21.1503 30.0333 22.1169 30.7999C22.4169 31.0333 22.7169 31.2333 23.0503 31.4166C24.3669 32.1166 25.9503 32.0333 27.2003 31.2166C30.9003 28.8333 33.3336 24.6999 33.3336 19.9999Z",
    fill: "white"
  })))
};
var VANTAGE = {
  id: "vantage",
  htmlID: "footer-vantage",
  name: "Vantage",
  link: "/vantage",
  target: "",
  logo: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "#77B22A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0668 12.8834C31.1502 12.8667 31.2001 12.7501 31.1502 12.6834C28.7668 9.06675 24.6668 6.66675 20.0001 6.66675C19.1835 6.66675 18.3835 6.75008 17.6168 6.88341C17.5335 6.90008 17.4835 7.00008 17.5335 7.08341C21.4168 14.0001 23.6668 14.9501 31.0668 12.8834Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6333 7.25008C16.6166 7.18342 16.5333 7.13342 16.4666 7.15008C10.8166 8.70008 6.66663 13.8668 6.66663 20.0001C6.66663 21.0667 6.79996 22.1168 7.03329 23.1001C7.04996 23.1834 7.14996 23.2334 7.23329 23.1834C16.7166 18.3501 18.9166 16.0668 16.6333 7.25008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.55 30.7667C27.5834 30.85 27.6834 30.8834 27.7667 30.8334C31.1334 28.4167 33.3334 24.4667 33.3334 20C33.3334 17.7667 32.7834 15.6667 31.8167 13.8167C31.7667 13.7167 31.6334 13.6834 31.5334 13.7334C24.5167 18.1667 24.5667 21.6834 27.55 30.7667Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.43328 23.9501C7.34994 23.9834 7.29994 24.0834 7.31661 24.1667C9.06661 29.5001 14.0833 33.3334 19.9833 33.3334C22.4833 33.3334 24.8333 32.6334 26.8333 31.4334C26.9 31.3834 26.9333 31.2834 26.8999 31.2167C21.8999 21.3834 18.8499 20.1001 7.43328 23.9501Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.6665 20.1001C22.9367 20.1001 23.9665 19.0703 23.9665 17.8001C23.9665 16.5298 22.9367 15.5001 21.6665 15.5001C20.3962 15.5001 19.3665 16.5298 19.3665 17.8001C19.3665 19.0703 20.3962 20.1001 21.6665 20.1001Z",
    fill: "white"
  })))
};
var CHAOS_PLAYER = {
  id: "chaos_player",
  htmlID: "footer-chaos_player",
  name: "Chaos Player",
  link: "/player",
  target: "",
  logo: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#12988B",
    d: "M0,0v40h40V0H0z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M20,6.6666017C12.6363277,6.6666017,6.6666017,12.6361332,6.6666017,20 c0,7.3637695,5.9697261,13.3333015,13.3333988,13.3333015S33.3333969,27.3637695,33.3333969,20 C33.3333969,12.6361332,27.3636723,6.6666017,20,6.6666017z M24.2765617,23.1620121 c0,0.1311512-0.076952,0.2501945-0.1964836,0.3040028l-10.1980467,4.5264664 c-0.1738281,0.0782223-0.3181639,0.0067368-0.3181639-0.1577148V12.2224607c0-0.1658201,0.1474609-0.3037109,0.3212891-0.222949 l10.1986332,4.7428703c0.1175766,0.0546875,0.1927719,0.172657,0.1927719,0.3023453V23.1620121z M29.7261715,20.924902 l-3.2867184,1.4792004c-0.1130867,0.0509758-0.2412109-0.0318375-0.2412109-0.1559582v-4.2547855 c0-0.125,0.1298828-0.2078114,0.2431641-0.155077l3.2943363,1.53125 C30.3998051,19.6782227,30.3941402,20.6243172,29.7261715,20.924902z"
  }))))
};
var CHAOS = {
  id: "chaos",
  htmlID: "footer-chaos",
  name: "Chaos Cloud",
  link: "/cloud",
  target: "",
  logo: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    width: "40",
    height: "40",
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40 0H0V40H40V0Z",
    fill: "#17A2DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.15 7.05014C16.7167 5.4668 10 8.9668 7.58334 15.1501C6.95001 16.7835 6.65001 18.4501 6.66667 20.0835C6.66667 20.2168 6.81667 20.3001 6.91667 20.2168C7.61667 19.7668 8.45001 19.4835 9.33334 19.4835C9.35001 19.4835 9.38334 19.4835 9.40001 19.4835C9.40001 19.1001 9.45001 18.7001 9.56667 18.3001C10.2167 16.3001 12.3667 15.1668 14.3833 15.8001C14.5833 15.8668 14.7667 15.9501 14.95 16.0335C16.4 13.1335 19.7667 11.6168 22.9667 12.6001C26.3 13.6335 28.25 17.0335 27.55 20.3835C27.8833 20.4168 28.2333 20.4835 28.5667 20.5835C30.5667 21.2001 31.8667 23.0168 31.9333 25.0001C31.9333 25.2168 32.2333 25.2668 32.3167 25.0668C32.4667 24.7168 32.6 24.3501 32.7167 23.9668C35 16.6668 30.6833 8.90014 23.15 7.05014Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9165 24.3168C26.4499 24.3001 25.9999 24.3668 25.5832 24.5334C25.5832 24.4501 25.5999 24.3834 25.5999 24.3001C25.7332 21.5001 23.5499 19.1334 20.7499 19.0001C18.0165 18.8834 15.7165 20.9334 15.4665 23.6168C14.9332 23.3001 14.3165 23.1001 13.6499 23.0668C11.5332 22.9668 9.7332 24.6168 9.6332 26.7334C9.5832 27.9001 10.0499 29.0001 10.8665 29.7334C11.0332 29.8834 11.1832 30.0168 11.1832 30.0168C12.5499 31.2001 14.1832 32.1501 16.0165 32.7334C20.3165 34.0668 24.7832 33.1168 28.0999 30.5668C28.6665 30.1334 29.1165 29.7501 29.3999 29.3834C29.7832 28.9001 30.0165 28.2834 30.0499 27.6334C30.1332 25.8668 28.7332 24.3834 26.9165 24.3168Z",
    fill: "white"
  })))
};
var ENSCAPE = {
  id: "enscape",
  htmlID: "footer-enscape",
  name: "Enscape",
  link: "https://www.enscape3d.com/",
  target: "_blank",
  logo: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "40",
    height: "40",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#F7941D",
    d: "M0,0v100h100V0H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M79.8082809,41.4213333L54.2136993,62.7873344 c-2.4428711,2.0402794-5.9786453,2.0413246-8.4235992,0.0030212L29.7151413,49.384449 c-0.640831-0.5345726-0.9316235-1.3834572-0.7541237-2.2019997l1.2324524-5.6832771 c0.1363678-0.6275826,0.8653984-0.9085312,1.3828983-0.5335846l14.8545628,10.7825203 c2.1339035,1.5481415,5.011097,1.5481415,7.1440163-0.0030212l23.5458794-17.1146011 c0.2276917-0.1657295,0.3219452-0.474987,0.2316055-0.7528534l-2.5450821-7.7862816 c-0.0601044-0.1829395-0.198555-0.3304749-0.3781357-0.4001713l-22.0125351-8.5704689 c-1.5524406-0.6053162-3.273201-0.6053162-4.8264961-0.0009861l-22.0226364,8.571455 c-0.1785393,0.0696964-0.3179054,0.2172318-0.3780727,0.4001713l-8.4887848,26.0064125 c-0.0801792,0.2455444-0.0160351,0.5144043,0.1655025,0.6972809L45.144371,81.2682419 c2.7356834,2.7537155,6.9834137,2.7537155,9.7181168-0.0010452l28.2771378-28.4802322 c0.1765213-0.1778831,0.2387085-0.4395866,0.1604843-0.6780968L79.8082809,41.4213333z M47.8228874,27.2974205 c1.3909798-0.6457157,2.9693718-0.6457157,4.3612061,0l9.7723465,4.5353107l-9.3652,5.6793308 c-1.6075287,0.9741554-3.5689507,0.9741554-5.1764755,0l-9.3642197-5.6793308L47.8228874,27.2974205z"
  })))))
};
var CYLINDO = {
  id: "cylindo",
  htmlID: "footer-cylindo",
  name: "Cylindo",
  link: "https://www.cylindo.com/",
  target: "_blank",
  logo: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    width: "40",
    height: "40",
    viewBox: "0 0 100 100",
    xmlSpace: "preserve"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Isolation_Mode"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#00B0BD",
    d: "M0,0v100h100V0H0z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M50,16.6660156C31.5898438,16.6660156,16.6660156,31.590332,16.6660156,50 c0,18.4091797,14.9238281,33.3330078,33.3339844,33.3330078c18.4091797,0,33.3330078-14.9238281,33.3330078-33.3330078 C83.3330078,31.590332,68.4091797,16.6660156,50,16.6660156z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B0BD",
    d: "M61.2988281,66.4140625C53.6176758,64.9077148,47.815918,58.1318359,47.815918,50 c0-8.1323242,5.8017578-14.9091797,13.4829102-16.4150391c0.3681641-0.0722656,0.6376953-0.3842773,0.6376953-0.7592773 V27.362793c0-0.3398438-0.2167969-0.6469727-0.5405273-0.7490234c-2.0844727-0.6621094-4.2792969-1.046875-6.5571289-1.1230469 c-12.9121094-0.4257812-24.1611328,9.4838867-25.2592773,22.355957 c-1.237793,14.5170898,10.1831055,26.675293,24.4301758,26.675293c2.5761719,0,5.0507812-0.3950195,7.387207-1.1362305 c0.3227539-0.1030273,0.5395508-0.4101562,0.5395508-0.7490234v-5.4638672 C61.9365234,66.7978516,61.6669922,66.4858398,61.2988281,66.4140625z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00B0BD",
    d: "M61.8813477,38.7011719C57.1083984,40.237793,53.6494141,44.7241211,53.6494141,50 c0,5.2749023,3.4589844,9.7617188,8.2319336,11.2978516c0.5068359,0.1630859,1.0288086-0.2109375,1.0288086-0.7441406V39.4448242 C62.9101562,38.9130859,62.3881836,38.5380859,61.8813477,38.7011719z"
  }))))))
};
var PRODUCTS = [CORONA, ENSCAPE, PHOENIX, VANTAGE, CHAOS_PLAYER, CYLINDO, CHAOS, VRAY, COSMOS, SCANS];
var pickLocale = function pickLocale(locale) {
  var parsedLocale = (locale || "").toLowerCase();
  if (parsedLocale === "en") {
    return "";
  } else {
    return parsedLocale;
  }
};
var buildProductLink = function buildProductLink(domain, link, locale) {
  if (link.substring(0, 4) === "http") return link;
  var correctLocale = pickLocale(locale);
  if (correctLocale) {
    return domain + "/" + correctLocale + link;
  } else {
    return "" + domain + link;
  }
};
var filterProducts = function filterProducts(products, visibleProducts) {
  return products.filter(function (p) {
    return visibleProducts[p.htmlID];
  });
};
var SlimFooter = function SlimFooter(_ref) {
  var locale = _ref.locale,
    domain = _ref.domain,
    visibleProducts = _ref.visibleProducts;
  return /*#__PURE__*/React.createElement("div", {
    className: s$k["slim-wrapper"]
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: s$k.slim
  }, /*#__PURE__*/React.createElement("div", {
    className: s$k["logos-wrapper"]
  }, /*#__PURE__*/React.createElement("a", {
    href: "https://www.chaos.com/" + pickLocale(locale)
  }, /*#__PURE__*/React.createElement("img", {
    src: LOGO$1,
    alt: "Chaos"
  }))), /*#__PURE__*/React.createElement("div", {
    className: s$k.products
  }, filterProducts(PRODUCTS, visibleProducts).map(function (product) {
    return /*#__PURE__*/React.createElement("a", {
      key: product.id,
      href: buildProductLink(domain, product.link, locale),
      id: product.htmlID,
      target: product.target
    }, product.logo);
  })))));
};
SlimFooter.defaultProps = {
  visibleProducts: {
    "footer-vray": true,
    "footer-cosmos": true,
    "footer-scans": true,
    "footer-corona": true,
    "footer-phoenix": true,
    "footer-vantage": true,
    "footer-chaos_player": true,
    "footer-chaos": true,
    "footer-enscape": true,
    "footer-cylindo": true
  }
};
var lfs = {
  "legal-wrapper": "_3NZT3",
  "copyright": "_KZ_a0",
  "cookie-consent": "_1Vomb",
  "legal-links": "_1Gm1U",
  "legal": "_-zlxR"
};
var CookieConsentBtn = function CookieConsentBtn(_ref) {
  var link = _ref.link,
    label = _ref.label,
    className = _ref.className,
    target = _ref.target,
    id = _ref.id;
  return /*#__PURE__*/React.createElement("a", {
    href: link,
    title: label,
    className: className + " " + lfs["cookie-consent"],
    target: target,
    id: id,
    onClick: function onClick(e) {
      e.preventDefault();
    }
  }, label);
};
var LegalFooter = function LegalFooter(_ref2) {
  var copyright = _ref2.copyright,
    links = _ref2.links,
    cookieConsent = _ref2.cookieConsent;
  return /*#__PURE__*/React.createElement("div", {
    className: lfs["legal-wrapper"]
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: lfs.legal
  }, /*#__PURE__*/React.createElement("div", {
    className: lfs.copyright
  }, copyright), /*#__PURE__*/React.createElement("div", {
    className: lfs["legal-links"]
  }, links.map(function (l) {
    return /*#__PURE__*/React.createElement(Link, {
      key: l.id,
      settings: l.link
    });
  }), cookieConsent && /*#__PURE__*/React.createElement(CookieConsentBtn, cookieConsent)))));
};
var s$l = {
  "pre-footer-wrapper": "_1WQ4r",
  "title": "_Ey0Mn",
  "description": "_2rJ2O",
  "form-wrapper": "_2Nsl_",
  "form-row": "_2giit",
  "hubspot-overrides": "_1xDtv",
  "btn-passive-light": "_FupwO",
  "text-wrapper": "_gisy_"
};
var ID = "chaos-footer-newsletter-hubspot-form-xdwdkl";
var HubSpotForm = function HubSpotForm(_ref) {
  var hubspotData = _ref.hubspotData,
    user = _ref.user;
  React.useEffect(function () {
    var script = document.createElement("script");
    script.src = "https://js.hsforms.net/forms/embed/v2.js";
    document.body.appendChild(script);
    script.addEventListener("load", function () {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId: hubspotData.portal_id,
          formId: hubspotData.form_id,
          region: hubspotData.region,
          target: "#" + ID,
          onFormReady: function onFormReady(_form) {
            var input = document.getElementById("email-" + hubspotData.form_id);
            input.value = (user === null || user === void 0 ? void 0 : user.email) || "";
          }
        });
      }
    });
  }, []);
  return /*#__PURE__*/React.createElement("div", {
    className: s$l["hubspot-overrides"],
    id: ID
  });
};
var PreFooter = function PreFooter(_ref) {
  var newsletter = _ref.newsletter,
    hubspotData = _ref.hubspotData,
    user = _ref.user;
  return /*#__PURE__*/React.createElement("div", {
    className: "pre-footer"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: s$l["pre-footer-wrapper"]
  }, /*#__PURE__*/React.createElement("div", {
    className: s$l["text-wrapper"]
  }, /*#__PURE__*/React.createElement("h3", {
    className: s$l.title
  }, newsletter === null || newsletter === void 0 ? void 0 : newsletter.title), /*#__PURE__*/React.createElement("div", {
    className: s$l.description,
    dangerouslySetInnerHTML: {
      __html: newsletter === null || newsletter === void 0 ? void 0 : newsletter.description
    }
  })), /*#__PURE__*/React.createElement(HubSpotForm, {
    hubspotData: hubspotData,
    user: user
  }))));
};
var DOMAIN = "https://www.chaos.com";
var SOCIAL_ICONS = {
  facebook: {
    id: "FB-footer",
    link: "https://www.facebook.com/chaosgroup",
    icon: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M15.664 4.65292H17.6724V1.15492C17.3259 1.10725 16.1343 1 14.7464 1C11.8507 1 9.86701 2.82142 9.86701 6.16908V9.25H6.67151V13.1605H9.86701V23H13.7848V13.1614H16.8511L17.3378 9.25092H13.7839V6.55683C13.7848 5.42658 14.0892 4.65292 15.664 4.65292Z",
      fill: "#1C1C1C"
    })))
  },
  twitter: {
    id: "TW-footer",
    link: "https://twitter.com/chaosgroup",
    icon: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
      width: "24",
      height: "24",
      x: "0px",
      y: "0px",
      viewBox: "0 0 1200 1227"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M689.1,540.3l348.5-405.1h-82.6L652.3,486.9L410.7,135.2H131.9L497.4,667l-365.5,424.8h82.6l319.5-371.5 l255.2,371.5h278.7L689.1,540.3L689.1,540.3z M576,671.7l-37.1-53L244.3,197.3h126.8l237.8,340.1l37.1,53L955,1032.5H828.2 L576,671.7L576,671.7z",
      fill: "#1C1C1C"
    })))
  },
  instagram: {
    id: "IG-footer",
    link: "https://www.instagram.com/chaosgroup/",
    icon: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M12.0035 6.35156C8.88406 6.35156 6.35864 8.87973 6.35864 11.9964C6.35864 15.1158 8.88681 17.6412 12.0035 17.6412C15.1229 17.6412 17.6483 15.1131 17.6483 11.9964C17.6483 8.87698 15.1201 6.35156 12.0035 6.35156ZM12.0035 15.6603C9.97856 15.6603 8.33956 14.0204 8.33956 11.9964C8.33956 9.9724 9.97948 8.33248 12.0035 8.33248C14.0275 8.33248 15.6674 9.9724 15.6674 11.9964C15.6683 14.0204 14.0284 15.6603 12.0035 15.6603Z",
      fill: "#1C1C1C"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M16.5356 1.06984C14.5116 0.97542 9.49838 0.980004 7.47255 1.06984C5.69238 1.15325 4.12213 1.58317 2.85621 2.84909C0.740547 4.96475 1.01096 7.81559 1.01096 11.9965C1.01096 16.2755 0.772631 19.0603 2.85621 21.1439C4.98013 23.2669 7.87221 22.9892 12.0036 22.9892C16.2423 22.9892 17.7053 22.9919 19.204 22.4117C21.2418 21.6206 22.78 19.7992 22.9303 16.5276C23.0256 14.5027 23.0201 9.49034 22.9303 7.4645C22.7488 3.60259 20.6762 1.2605 16.5356 1.06984ZM19.7394 19.7442C18.3525 21.1311 16.4284 21.0073 11.977 21.0073C7.39371 21.0073 5.5558 21.0752 4.21471 19.7304C2.67013 18.1932 2.94971 15.7246 2.94971 11.9818C2.94971 6.91725 2.42996 3.26984 7.51288 3.0095C8.68071 2.96825 9.02446 2.9545 11.9642 2.9545L12.0055 2.982C16.8904 2.982 20.723 2.4705 20.953 7.5525C21.0053 8.71209 21.0172 9.06042 21.0172 11.9956C21.0163 16.5258 21.1025 18.3747 19.7394 19.7442Z",
      fill: "#1C1C1C"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M17.8719 7.44773C18.6005 7.44773 19.191 6.85716 19.191 6.12865C19.191 5.40014 18.6005 4.80957 17.8719 4.80957C17.1434 4.80957 16.5529 5.40014 16.5529 6.12865C16.5529 6.85716 17.1434 7.44773 17.8719 7.44773Z",
      fill: "#1C1C1C"
    })))
  },
  youtube: {
    id: "YT-footer",
    link: "https://www.youtube.com/chaosgrouptv",
    icon: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M22.5133 6.43485L22.5408 6.61451C22.2749 5.67126 21.5572 4.94343 20.6451 4.67851L20.6259 4.67393C18.9108 4.20826 12.0092 4.20826 12.0092 4.20826C12.0092 4.20826 5.12503 4.1991 3.39253 4.67393C2.46303 4.94343 1.74436 5.67126 1.48311 6.59526L1.47853 6.61451C0.837776 9.96126 0.833192 13.9827 1.50694 17.5659L1.47853 17.3844C1.74436 18.3277 2.46211 19.0555 3.37419 19.3204L3.39344 19.325C5.10669 19.7916 12.0101 19.7916 12.0101 19.7916C12.0101 19.7916 18.8934 19.7916 20.6268 19.325C21.5572 19.0555 22.2759 18.3277 22.5371 17.4037L22.5417 17.3844C22.8332 15.8279 23 14.0368 23 12.2071C23 12.1402 23 12.0723 22.9991 12.0045C23 11.9422 23 11.8679 23 11.7937C23 9.9631 22.8332 8.17193 22.5133 6.43485ZM9.80736 15.3467V8.66143L15.5512 12.0091L9.80736 15.3467Z",
      fill: "#1C1C1C"
    })))
  },
  linkedin: {
    id: "IN-footer",
    link: "https://www.linkedin.com/company/chaos-group",
    icon: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M23.1377 22.3655L23.1432 22.3646V15.2961C23.1432 11.3489 22.2935 8.30835 17.679 8.30835C15.4606 8.30835 13.972 9.52568 13.3642 10.6798H13.3001V8.67685H8.9248V22.3646H13.4806V16.0918C13.4806 14.1769 13.8436 12.3252 16.2151 12.3252C18.5516 12.3252 18.5865 14.5105 18.5865 16.2146V22.3655H23.1377Z",
      fill: "#1C1C1C"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M1.36328 8.67773H5.92462V22.3655H1.36328V8.67773Z",
      fill: "#1C1C1C"
    }), /*#__PURE__*/React.createElement("path", {
      d: "M3.64183 1C2.18342 1 1 2.18342 1 3.64183C1 5.10025 2.18342 6.30842 3.64183 6.30842C5.10025 6.30842 6.28367 5.10025 6.28367 3.64183C6.28275 2.18342 5.09933 1 3.64183 1V1Z",
      fill: "#1C1C1C"
    })))
  },
  blogger: {
    id: "BL-footer",
    link: "http://vraymasters.cn/",
    icon: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
      width: "24px",
      height: "24px",
      viewBox: "0 0 24 24",
      version: "1.1"
    }, /*#__PURE__*/React.createElement("title", null, "blogger-black"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
      id: "blogger-black",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("g", {
      id: "blogger",
      fill: "#000000",
      fillRule: "nonzero"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M21.976,24 L2.026,24 C0.9,24 0,23.1 0,21.976 L0,2.026 C0,0.9 0.9,0 2.025,0 L22.05,0 C23.1,0 24,0.9 24,2.025 L24,21.975 C24,23.1 23.1,24 21.976,24 Z M12,3.975 L9,3.975 C6.225,3.975 3.975,6.225 3.975,9 L3.975,15 C3.975,17.774 6.225,20.024 9,20.024 L15,20.024 C17.774,20.024 20.024,17.774 20.024,15 L20.024,11.025 C20.024,10.425 19.574,9.975 18.974,9.975 L18,9.975 C17.476,9.975 17.024,9.525 17.024,8.999 C17.024,6.223 14.774,3.973 12,3.973 L12,3.975 Z M15.074,15.975 L9,15.975 C8.475,15.975 8.025,15.525 8.025,15 C8.025,14.475 8.475,14.024 9,14.024 L15.074,14.024 C15.6,14.024 16.051,14.474 16.051,15 C16.051,15.526 15.601,15.976 15.076,15.976 L15.074,15.975 Z M12.524,8.025 C13.051,8.025 13.5,8.475 13.5,9 C13.5,9.525 13.05,9.975 12.525,9.975 L8.925,9.975 C8.4,9.975 7.949,9.525 7.949,9 C7.949,8.475 8.399,8.025 8.924,8.025 L12.524,8.025 Z",
      id: "Shape"
    })))))
  },
  youku: {
    id: "YK-footer",
    link: "http://i.youku.com/i/UMzI1MDU0Njc2NA==",
    icon: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
      width: "24px",
      height: "24px",
      viewBox: "0 0 24 24",
      version: "1.1"
    }, /*#__PURE__*/React.createElement("title", null, "youku-black"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
      id: "youku-black",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("g", {
      id: "youtube",
      transform: "translate(0.000000, 3.000000)",
      fill: "#000000",
      fillRule: "nonzero"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M23.495,3.205 C23.212191,2.19165677 22.4203432,1.39980902 21.407,1.117 C19.537,0.616 12.011,0.616 12.011,0.616 C12.011,0.616 4.504,0.606 2.615,1.117 C1.60165677,1.39980902 0.809809023,2.19165677 0.527,3.205 C0.172520594,5.11951056 -0.00223945169,7.06296279 0.005,9.01 C-0.000870868833,10.9496902 0.173883448,12.8857136 0.527,14.793 C0.809809023,15.8063432 1.60165677,16.598191 2.615,16.881 C4.483,17.383 12.011,17.383 12.011,17.383 C12.011,17.383 19.517,17.383 21.407,16.881 C22.4203432,16.598191 23.212191,15.8063432 23.495,14.793 C23.8407392,12.8850228 24.0081279,10.949005 23.995,9.01 C24.0094964,7.06365058 23.8421022,5.12020397 23.495,3.205 L23.495,3.205 Z M9.609,12.601 L9.609,5.408 L15.873,9.01 L9.609,12.601 Z",
      id: "Shape"
    })))))
  },
  weibo: {
    id: "WB-footer",
    link: "http://www.weibo.com/5676229613/profile?topnav=1&wvr=6&is_all=1",
    icon: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("svg", {
      width: "24px",
      height: "24px",
      viewBox: "0 0 24 24",
      version: "1.1"
    }, /*#__PURE__*/React.createElement("title", null, "weibo-black"), /*#__PURE__*/React.createElement("desc", null, "Created with Sketch."), /*#__PURE__*/React.createElement("g", {
      id: "weibo-black",
      stroke: "none",
      strokeWidth: "1",
      fill: "none",
      fillRule: "evenodd"
    }, /*#__PURE__*/React.createElement("g", {
      id: "sinaweibo",
      transform: "translate(0.000000, 2.000000)",
      fill: "#000000",
      fillRule: "nonzero"
    }, /*#__PURE__*/React.createElement("path", {
      d: "M10.098,18.323 C6.121,18.714 2.684,16.917 2.426,14.303 C2.167,11.694 5.185,9.256 9.166,8.862 C13.145,8.468 16.579,10.266 16.837,12.88 C17.096,15.48 14.078,17.929 10.1,18.319 L10.098,18.323 Z M9.05,15.219 C8.666,15.835 7.842,16.103 7.221,15.821 C6.609,15.542 6.428,14.83 6.815,14.228 C7.194,13.633 7.991,13.367 8.608,13.627 C9.23,13.89 9.428,14.599 9.05,15.219 Z M10.32,13.592 C10.179,13.829 9.871,13.945 9.631,13.845 C9.395,13.755 9.318,13.484 9.454,13.259 C9.592,13.032 9.89,12.913 10.126,13.019 C10.365,13.109 10.441,13.379 10.306,13.62 L10.32,13.592 Z M10.496,10.873 C8.603,10.38 6.463,11.323 5.639,12.991 C4.803,14.695 5.613,16.582 7.525,17.201 C9.508,17.841 11.843,16.86 12.657,15.022 C13.457,13.229 12.456,11.38 10.496,10.873 Z M18.059,9.649 C17.713,9.544 17.489,9.469 17.654,9.034 C18.029,8.057 18.074,7.23 17.654,6.63 C16.873,5.518 14.739,5.577 12.29,6.6 C12.29,6.6 11.524,6.931 11.719,6.329 C12.095,5.112 12.034,4.105 11.449,3.52 C10.111,2.183 6.58,3.565 3.561,6.6 C1.309,8.87 0,11.273 0,13.348 C0,17.329 5.099,19.743 10.086,19.743 C16.622,19.743 20.974,15.942 20.974,12.923 C20.974,11.101 19.427,10.069 18.059,9.639 L18.059,9.649 Z M19.967,4.557 C19.201,3.701 18.059,3.37 17.007,3.595 C16.571,3.685 16.301,4.106 16.391,4.527 C16.481,4.947 16.902,5.218 17.323,5.129 C17.834,5.024 18.39,5.173 18.765,5.594 C19.141,6.015 19.231,6.571 19.081,7.067 C18.945,7.473 19.17,7.923 19.591,8.059 C19.996,8.178 20.448,7.954 20.583,7.547 C20.913,6.526 20.703,5.369 19.937,4.512 L19.967,4.557 Z M22.385,2.362 C20.809,0.605 18.48,-0.057 16.331,0.394 C15.835,0.498 15.519,0.981 15.625,1.475 C15.729,1.971 16.211,2.288 16.707,2.182 C18.239,1.851 19.892,2.332 21.003,3.565 C22.115,4.811 22.432,6.508 21.95,7.981 C21.785,8.461 22.056,8.988 22.536,9.138 C23.015,9.303 23.527,9.034 23.693,8.552 C24.368,6.464 23.934,4.074 22.355,2.317 L22.385,2.362 Z",
      id: "Shape"
    })))))
  }
};
var LinkColumn = function LinkColumn(_ref) {
  var title = _ref.title,
    links = _ref.links;
  return /*#__PURE__*/React.createElement("div", {
    className: fs.links
  }, /*#__PURE__*/React.createElement("h6", null, title), /*#__PURE__*/React.createElement("ul", null, links.map(function (l) {
    return /*#__PURE__*/React.createElement("li", {
      key: l.id
    }, /*#__PURE__*/React.createElement(Link, {
      settings: l.link
    }));
  })));
};
var FooterColumn = function FooterColumn(_ref2) {
  var title = _ref2.title,
    links = _ref2.links,
    fullSet = _ref2.fullSet;
  var ItemComponent = fullSet ? FixedFlexItem : FlexItem;
  return title && links.length > 0 && /*#__PURE__*/React.createElement(ItemComponent, {
    setWidth: fullSet
  }, /*#__PURE__*/React.createElement(LinkColumn, {
    title: title,
    links: links
  }));
};
function Footer(_ref3) {
  var _data$hubspot;
  var data = _ref3.data,
    user = _ref3.user,
    locale = _ref3.locale,
    visibleProducts = _ref3.visibleProducts,
    _ref3$hidePreFooter = _ref3.hidePreFooter,
    hidePreFooter = _ref3$hidePreFooter === void 0 ? false : _ref3$hidePreFooter;
  var fullSet = [data.column_1_title, data.column_1_links.length > 0, data.column_2_title, data.column_2_links.length > 0, data.column_3_title, data.column_3_links.length > 0, data.column_4_title, data.column_4_links.length > 0, data.column_5_title, data.column_5_links.length > 0].every(function (item) {
    return Boolean(item);
  });
  var ContainerComponent = fullSet ? WrappableFlexContainer : FlexContainer;
  return /*#__PURE__*/React.createElement("div", {
    className: fs.footer
  }, (data === null || data === void 0 ? void 0 : (_data$hubspot = data.hubspot) === null || _data$hubspot === void 0 ? void 0 : _data$hubspot.form_id) && !hidePreFooter && /*#__PURE__*/React.createElement(PreFooter, {
    newsletter: data.newsletter,
    hubspotData: data.hubspot,
    user: user
  }), /*#__PURE__*/React.createElement(SlimFooter, {
    locale: locale,
    domain: DOMAIN,
    visibleProducts: visibleProducts
  }), /*#__PURE__*/React.createElement(Spacing, {
    s: "both-sm"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(ContainerComponent, null, /*#__PURE__*/React.createElement(FooterColumn, {
    fullSet: fullSet,
    title: data.column_1_title,
    links: data.column_1_links
  }), /*#__PURE__*/React.createElement(FooterColumn, {
    fullSet: fullSet,
    title: data.column_2_title,
    links: data.column_2_links
  }), /*#__PURE__*/React.createElement(FooterColumn, {
    fullSet: fullSet,
    title: data.column_3_title,
    links: data.column_3_links
  }), /*#__PURE__*/React.createElement(FooterColumn, {
    fullSet: fullSet,
    title: data.column_4_title,
    links: data.column_4_links
  }), /*#__PURE__*/React.createElement(FooterColumn, {
    fullSet: fullSet,
    title: data.column_5_title,
    links: data.column_5_links
  }), /*#__PURE__*/React.createElement(FlexItem, null, /*#__PURE__*/React.createElement("div", {
    className: fs.links
  }, /*#__PURE__*/React.createElement("h6", null, data.follow_us), /*#__PURE__*/React.createElement("div", {
    className: fs.social
  }, data.social_icons.map(function (l) {
    return SOCIAL_ICONS[l.icon] && /*#__PURE__*/React.createElement("a", {
      key: l.icon,
      href: SOCIAL_ICONS[l.icon].link,
      id: SOCIAL_ICONS[l.icon].id,
      target: "_blank",
      rel: "noreferrer"
    }, /*#__PURE__*/React.createElement("div", null, SOCIAL_ICONS[l.icon].icon));
  }))))))), /*#__PURE__*/React.createElement(LegalFooter, {
    copyright: data.copyright,
    links: data.slim_links,
    cookieConsent: data.slim_cookie_consent
  }));
}
var DOMAIN$1 = "https://www.chaos.com";
var Placeholder = function Placeholder(_ref) {
  var locale = _ref.locale;
  return /*#__PURE__*/React.createElement(SlimFooter, {
    locale: locale,
    domain: DOMAIN$1
  });
};
var FONT_HEIGHT = "2em";
var TEXT_WIDTH = "50px";
var HSTACK = {
  display: "flex",
  gap: "1em"
};
var Placeholder$1 = function Placeholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: lfs["legal-wrapper"]
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: lfs.legal
  }, /*#__PURE__*/React.createElement("div", {
    className: lfs.copyright
  }, /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "400px",
      height: "34px"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: HSTACK
  }, /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH,
      height: FONT_HEIGHT
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH,
      height: FONT_HEIGHT
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH,
      height: FONT_HEIGHT
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH,
      height: FONT_HEIGHT
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH,
      height: FONT_HEIGHT
    }
  })))));
};
var Placeholder$2 = function Placeholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: "pre-footer"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement("div", {
    className: s$l["pre-footer-wrapper"]
  }, /*#__PURE__*/React.createElement("div", {
    className: s$l["text-wrapper"]
  }, /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "200px",
      height: "42px"
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "200px",
      height: "32px"
    }
  })), /*#__PURE__*/React.createElement("div", {
    className: s$l["hubspot-overrides"]
  }, /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "500px",
      height: "175px"
    }
  })))));
};
var FONT_HEIGHT$1 = "2em";
var TEXT_WIDTH$1 = "100px";
var VSTACK = {
  display: "flex",
  flexDirection: "column",
  gap: "1em"
};
var LinkColumn$1 = function LinkColumn() {
  return /*#__PURE__*/React.createElement("div", {
    style: VSTACK
  }, /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH$1,
      height: FONT_HEIGHT$1
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH$1,
      height: FONT_HEIGHT$1
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH$1,
      height: FONT_HEIGHT$1
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH$1,
      height: FONT_HEIGHT$1
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH$1,
      height: FONT_HEIGHT$1
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH$1,
      height: FONT_HEIGHT$1
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH$1,
      height: FONT_HEIGHT$1
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH$1,
      height: "3px"
    }
  }));
};
var FooterPlaceholder = function FooterPlaceholder(_ref) {
  var locale = _ref.locale,
    hidePreFooter = _ref.hidePreFooter;
  return /*#__PURE__*/React.createElement("div", {
    className: fs.footer
  }, !hidePreFooter && /*#__PURE__*/React.createElement(Placeholder$2, null), /*#__PURE__*/React.createElement(Placeholder, {
    locale: locale
  }), /*#__PURE__*/React.createElement(Spacing, {
    s: "both-sm"
  }, /*#__PURE__*/React.createElement(Container, null, /*#__PURE__*/React.createElement(FlexContainer, null, /*#__PURE__*/React.createElement(FlexItem, null, /*#__PURE__*/React.createElement(LinkColumn$1, null)), /*#__PURE__*/React.createElement(FlexItem, null, /*#__PURE__*/React.createElement(LinkColumn$1, null)), /*#__PURE__*/React.createElement(FlexItem, null, /*#__PURE__*/React.createElement(LinkColumn$1, null)), /*#__PURE__*/React.createElement(FlexItem, null, /*#__PURE__*/React.createElement(LinkColumn$1, null)), /*#__PURE__*/React.createElement(FlexItem, null, /*#__PURE__*/React.createElement(LinkColumn$1, null)), /*#__PURE__*/React.createElement(FlexItem, null, /*#__PURE__*/React.createElement("div", {
    className: fs.links
  }, /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: TEXT_WIDTH$1,
      height: FONT_HEIGHT$1,
      marginBottom: "1em"
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: fs.social
  }, /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "24px",
      height: FONT_HEIGHT$1
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "24px",
      height: FONT_HEIGHT$1
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "24px",
      height: FONT_HEIGHT$1
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "24px",
      height: FONT_HEIGHT$1
    }
  }), /*#__PURE__*/React.createElement(Rectangle, {
    style: {
      width: "24px",
      height: FONT_HEIGHT$1
    }
  }))))))), /*#__PURE__*/React.createElement(Placeholder$1, null));
};
var index$1 = withApiData(Footer, FooterPlaceholder);
var s$m = {
  "landing-header": "_gZKP-"
};
var LOGO$2 = "data:image/svg+xml;base64,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";
function LandingHeader(_ref) {
  var url = _ref.url;
  return /*#__PURE__*/React.createElement("div", {
    className: s$m["landing-header"]
  }, /*#__PURE__*/React.createElement("a", {
    href: url
  }, /*#__PURE__*/React.createElement("img", {
    src: LOGO$2
  })));
}
function LandingFooter(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React.createElement("div", {
    className: fs.footer
  }, /*#__PURE__*/React.createElement(LegalFooter, {
    copyright: data.copyright,
    links: data.slim_links,
    cookieConsent: data.slim_cookie_consent
  }));
}
var HeaderPlaceholder$1 = function HeaderPlaceholder() {
  return /*#__PURE__*/React.createElement("div", {
    className: fs.footer
  }, /*#__PURE__*/React.createElement(Placeholder$1, null));
};
var index$2 = withApiData(LandingFooter, HeaderPlaceholder$1);
var DOMAIN$2 = "https://www.chaos.com";
function LandingFooter$1(_ref) {
  var locale = _ref.locale,
    data = _ref.data,
    visibleProducts = _ref.visibleProducts;
  return /*#__PURE__*/React.createElement("div", {
    className: fs.footer
  }, /*#__PURE__*/React.createElement(SlimFooter, {
    locale: locale,
    domain: DOMAIN$2,
    visibleProducts: visibleProducts
  }), /*#__PURE__*/React.createElement(LegalFooter, {
    copyright: data.copyright,
    links: data.slim_links,
    cookieConsent: data.slim_cookie_consent
  }));
}
var HeaderPlaceholder$2 = function HeaderPlaceholder(_ref) {
  var locale = _ref.locale;
  return /*#__PURE__*/React.createElement("div", {
    className: fs.footer
  }, /*#__PURE__*/React.createElement(Placeholder, {
    locale: locale
  }), /*#__PURE__*/React.createElement(Placeholder$1, null));
};
var index$3 = withApiData(LandingFooter$1, HeaderPlaceholder$2);
export { index$1 as Footer, index as Header, index$2 as LandingFooter, LandingHeader, index$3 as MidFooter };